var _g, _path, _path2, _path3, _circle, _circle2, _ellipse, _feBlend, _feBlend2, _feBlend3, _feBlend4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      enableBackground: "new 0 0 1122 1122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "object"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_585_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_778_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_794_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_798_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M910.831,821.769H562.285c-2.362,0-4.276-1.914-4.276-4.276V342.786 c0-2.362,1.914-4.276,4.276-4.276h348.546c2.362,0,4.276,1.914,4.276,4.276v474.706 C915.107,819.854,913.193,821.769,910.831,821.769z M566.561,813.216h339.993V347.063H566.561V813.216z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_797_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M910.831,821.769H562.285c-2.362,0-4.276-1.914-4.276-4.276V342.786 c0-2.362,1.914-4.276,4.276-4.276h348.546c2.362,0,4.276,1.914,4.276,4.276v474.706 C915.107,819.854,913.193,821.769,910.831,821.769z M566.561,813.216h339.993V347.063H566.561V813.216z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_779_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_793_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.135,450.771H576.207c-2.362,0-4.276-1.914-4.276-4.276v-87.671 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C898.412,448.856,896.498,450.771,894.135,450.771z M580.483,442.218h309.376V363.1H580.483V442.218z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_792_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.135,554.479H576.207c-2.362,0-4.276-1.914-4.276-4.276v-87.671 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C898.412,552.565,896.498,554.479,894.135,554.479z M580.483,545.926h309.376v-79.118H580.483V545.926z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_791_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.135,659.257H576.207c-2.362,0-4.276-1.914-4.276-4.276V567.31 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C898.412,657.343,896.498,659.257,894.135,659.257z M580.483,650.704h309.376v-79.118H580.483V650.704z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_786_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.135,764.034H576.207c-2.362,0-4.276-1.914-4.276-4.276v-87.671 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C898.412,762.12,896.498,764.034,894.135,764.034z M580.483,755.481h309.376v-79.118H580.483V755.481z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_785_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.848,450.771H576.919c-2.362,0-4.276-1.914-4.276-4.276v-87.671 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C899.125,448.856,897.211,450.771,894.848,450.771z M581.196,442.218h309.376V363.1H581.196V442.218z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_784_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.848,554.479H576.919c-2.362,0-4.276-1.914-4.276-4.276v-87.671 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C899.125,552.565,897.211,554.479,894.848,554.479z M581.196,545.926h309.376v-79.118H581.196V545.926z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_783_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.848,659.257H576.919c-2.362,0-4.276-1.914-4.276-4.276V567.31 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C899.125,657.343,897.211,659.257,894.848,659.257z M581.196,650.704h309.376v-79.118H581.196V650.704z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_780_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M894.848,764.034H576.919c-2.362,0-4.276-1.914-4.276-4.276v-87.671 c0-2.362,1.914-4.276,4.276-4.276h317.929c2.362,0,4.276,1.914,4.276,4.276v87.671 C899.125,762.12,897.211,764.034,894.848,764.034z M581.196,755.481h309.376v-79.118H581.196V755.481z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_777_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M593.404,446.494h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-67.714 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v67.714 C595.543,445.536,594.585,446.494,593.404,446.494z M584.738,442.217h6.527V378.78h-6.527V442.217z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_772_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M605.165,446.494H594.36c-1.181,0-2.139-0.958-2.139-2.139v-67.714 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v67.714 C607.303,445.536,606.345,446.494,605.165,446.494z M596.499,442.217h6.527V378.78h-6.527V442.217z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_771_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M616.925,446.494h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-61.629 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v61.629 C619.064,445.536,618.106,446.494,616.925,446.494z M608.259,442.217h6.527v-57.352h-6.527V442.217z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_770_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M628.686,446.494h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-67.714 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v67.714 C630.825,445.536,629.867,446.494,628.686,446.494z M620.02,442.217h6.527V378.78h-6.527V442.217z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_769_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M656.922,445.707c-0.255,0-0.51-0.046-0.754-0.138c-0.53-0.199-0.96-0.603-1.194-1.119 l-27.938-61.682c-0.487-1.075-0.01-2.343,1.066-2.83l9.842-4.458c0.516-0.233,1.103-0.253,1.636-0.053 c0.53,0.199,0.96,0.603,1.194,1.119l27.938,61.682c0.487,1.075,0.01,2.343-1.066,2.83l-9.842,4.458 C657.525,445.643,657.224,445.707,656.922,445.707z M631.814,382.952l26.174,57.786l5.946-2.693l-26.174-57.786L631.814,382.952z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_766_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M885.942,550.203h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-67.714 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v67.714 C888.081,549.245,887.123,550.203,885.942,550.203z M877.277,545.926h6.526v-63.436h-6.526V545.926z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_765_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M874.181,550.203h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-67.714 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v67.714 C876.32,549.245,875.362,550.203,874.181,550.203z M865.516,545.926h6.526v-63.436h-6.526V545.926z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_764_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M862.42,550.203h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-61.629 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v61.629 C864.559,549.245,863.601,550.203,862.42,550.203z M853.755,545.926h6.526v-57.352h-6.526V545.926z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_762_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M850.66,550.203h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-67.714 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v67.714C852.798,549.245,851.84,550.203,850.66,550.203 z M841.995,545.926h6.526v-63.436h-6.526V545.926z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_757_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M592.869,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v67.715 C595.007,654.558,594.049,655.516,592.869,655.516z M584.203,651.238h6.527v-63.438h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_756_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M604.629,655.516h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v67.715 C606.768,654.558,605.81,655.516,604.629,655.516z M595.964,651.238h6.526v-63.438h-6.526V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_755_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M616.39,655.516h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-61.63 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v61.63C618.529,654.558,617.571,655.516,616.39,655.516 z M607.725,651.238h6.526v-57.353h-6.526V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_754_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M628.151,655.516h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v67.715 C630.29,654.558,629.332,655.516,628.151,655.516z M619.486,651.238h6.526v-63.438h-6.526V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_753_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M639.378,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v67.715 C641.516,654.558,640.558,655.516,639.378,655.516z M630.711,651.238h6.527v-63.438h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_748_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M651.138,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v67.715 C653.277,654.558,652.319,655.516,651.138,655.516z M642.472,651.238H649v-63.438h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_747_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M662.899,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-61.63 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v61.63C665.038,654.558,664.08,655.516,662.899,655.516 z M654.233,651.238h6.527v-57.353h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_657_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M674.66,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-60.986 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v60.986C676.798,654.558,675.84,655.516,674.66,655.516 z M665.994,651.238h6.527v-56.709h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_656_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M686.42,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139V592.15 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v61.227 C688.559,654.558,687.601,655.516,686.42,655.516z M677.754,651.238h6.527v-56.949h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_655_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M698.181,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-61.089 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v61.089 C700.32,654.558,699.362,655.516,698.181,655.516z M689.515,651.238h6.527v-56.811h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_654_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M709.942,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-61.63 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v61.63 C712.081,654.558,711.123,655.516,709.942,655.516z M701.276,651.238h6.527v-57.353h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_653_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M721.703,655.516h-10.805c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.805c1.181,0,2.139,0.958,2.139,2.139v67.715 C723.841,654.558,722.883,655.516,721.703,655.516z M713.037,651.238h6.527v-63.438h-6.527V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_652_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M732.928,655.516h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v67.715 C735.067,654.558,734.109,655.516,732.928,655.516z M724.263,651.238h6.526v-63.438h-6.526V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_651_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M744.689,655.516h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-67.715 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v67.715 C746.828,654.558,745.87,655.516,744.689,655.516z M736.024,651.238h6.526v-63.438h-6.526V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_650_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M756.45,655.516h-10.804c-1.181,0-2.139-0.958-2.139-2.139v-61.63 c0-1.181,0.958-2.139,2.139-2.139h10.804c1.181,0,2.139,0.958,2.139,2.139v61.63C758.589,654.558,757.63,655.516,756.45,655.516z  M747.785,651.238h6.526v-57.353h-6.526V651.238z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_649_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M780.764,654.938c-0.749,0-1.477-0.394-1.868-1.095l-24.667-44.112 c-0.277-0.495-0.346-1.08-0.191-1.626c0.154-0.546,0.519-1.008,1.014-1.284l9.431-5.273c1.029-0.574,2.334-0.208,2.91,0.822 l24.667,44.112c0.277,0.495,0.346,1.08,0.191,1.626c-0.154,0.546-0.519,1.008-1.014,1.284l-9.431,5.273 C781.476,654.85,781.118,654.938,780.764,654.938z M759.005,609.509l22.579,40.38l5.698-3.186l-22.579-40.38L759.005,609.509z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_648_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M811.619,549.416c-0.302,0-0.603-0.064-0.882-0.19l-9.842-4.458 c-1.076-0.487-1.554-1.755-1.066-2.83l27.938-61.682c0.234-0.517,0.664-0.92,1.194-1.119c0.53-0.2,1.121-0.18,1.636,0.053 l9.842,4.458c1.076,0.487,1.554,1.755,1.066,2.83l-27.938,61.682c-0.234,0.517-0.664,0.92-1.194,1.119 C812.129,549.37,811.874,549.416,811.619,549.416z M804.607,541.754l5.946,2.693l26.174-57.786l-5.946-2.693L804.607,541.754z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_539_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_931_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_941_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_943_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M518.13,813.034H213.853c-2.062,0-3.733-1.672-3.733-3.733V394.886 c0-2.062,1.671-3.733,3.733-3.733H518.13c2.062,0,3.733,1.672,3.733,3.733v414.415 C521.864,811.362,520.193,813.034,518.13,813.034z M217.586,805.567h296.811V398.619H217.586V805.567z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_942_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M518.13,813.034H213.853c-2.062,0-3.733-1.672-3.733-3.733V394.886 c0-2.062,1.671-3.733,3.733-3.733H518.13c2.062,0,3.733,1.672,3.733,3.733v414.415 C521.864,811.362,520.193,813.034,518.13,813.034z M217.586,805.567h296.811V398.619H217.586V805.567z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_932_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_940_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.977,489.156H228.428c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.061,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.711,487.484,508.039,489.156,505.977,489.156z M232.161,481.69h270.083V412.62H232.161V481.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_939_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.977,579.692H228.428c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.062,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.711,578.021,508.039,579.692,505.977,579.692z M232.161,572.226h270.083v-69.069H232.161V572.226z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_938_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.977,671.162H228.428c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.061,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.711,669.49,508.039,671.162,505.977,671.162z M232.161,663.695h270.083v-69.069H232.161V663.695z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_937_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.977,762.633H228.428c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.061,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.711,760.961,508.039,762.633,505.977,762.633z M232.161,755.166h270.083v-69.069H232.161V755.166z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_936_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.355,489.156H227.806c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.061,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.089,487.484,507.417,489.156,505.355,489.156z M231.539,481.69h270.082V412.62H231.539V481.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_935_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.355,579.692H227.806c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.062,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.089,578.021,507.417,579.692,505.355,579.692z M231.539,572.226h270.082v-69.069H231.539V572.226z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_934_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.355,671.162H227.806c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.061,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.089,669.49,507.417,671.162,505.355,671.162z M231.539,663.695h270.082v-69.069H231.539V663.695z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_933_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M505.355,762.633H227.806c-2.062,0-3.733-1.672-3.733-3.733v-76.536 c0-2.061,1.671-3.733,3.733-3.733h277.549c2.062,0,3.733,1.672,3.733,3.733v76.536 C509.089,760.961,507.417,762.633,505.355,762.633z M231.539,755.166h270.082v-69.069H231.539V755.166z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_923_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M500.397,485.423h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114 C502.263,484.587,501.427,485.423,500.397,485.423z M492.831,481.689h5.699v-55.38h-5.699V481.689z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_922_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M490.129,485.423h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C491.996,484.587,491.16,485.423,490.129,485.423 z M482.564,481.689h5.699v-55.38h-5.699V481.689z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_921_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M479.862,485.423h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.802 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.802 C481.729,484.587,480.893,485.423,479.862,485.423z M472.297,481.689h5.699v-50.067h-5.699V481.689z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_920_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M469.595,485.423h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114 C471.462,484.587,470.626,485.423,469.595,485.423z M462.03,481.689h5.699v-55.38h-5.699V481.689z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_917_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M435.511,484.735c-0.258,0-0.52-0.054-0.769-0.167l-8.592-3.892 c-0.451-0.204-0.803-0.579-0.977-1.042c-0.174-0.464-0.158-0.978,0.047-1.429l24.391-53.848c0.426-0.939,1.535-1.354,2.47-0.93 l8.592,3.892c0.451,0.204,0.803,0.579,0.977,1.042c0.174,0.464,0.158,0.978-0.047,1.429l-24.391,53.848 C436.9,484.327,436.222,484.735,435.511,484.735z M429.391,478.046l5.191,2.352l22.85-50.446l-5.191-2.352L429.391,478.046z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_916_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M245.012,575.96h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C246.879,575.124,246.043,575.96,245.012,575.96z  M237.447,572.226h5.699v-55.38h-5.699V572.226z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_915_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M255.279,575.96h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C257.146,575.124,256.31,575.96,255.279,575.96z  M247.714,572.226h5.699v-55.38h-5.699V572.226z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_914_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M265.546,575.96h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.802 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.802C267.413,575.124,266.577,575.96,265.546,575.96z  M257.981,572.226h5.699v-50.067h-5.699V572.226z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_911_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M275.814,575.96h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C277.68,575.124,276.844,575.96,275.814,575.96z  M268.248,572.226h5.699v-55.38h-5.699V572.226z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_910_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M500.863,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C502.73,667.06,501.894,667.896,500.863,667.896z  M493.297,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_909_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M490.596,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C492.462,667.06,491.627,667.896,490.596,667.896 z M483.03,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_908_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M480.329,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.802 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.802C482.196,667.06,481.36,667.896,480.329,667.896z  M472.764,664.162h5.699v-50.067h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_903_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M470.062,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C471.929,667.06,471.093,667.896,470.062,667.896 z M462.497,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_902_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M460.261,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C462.128,667.06,461.292,667.896,460.261,667.896 z M452.696,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_901_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M449.995,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C451.861,667.06,451.025,667.896,449.995,667.896 z M442.429,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_900_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M439.728,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.802 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.802C441.594,667.06,440.758,667.896,439.728,667.896 z M432.162,664.162h5.699v-50.067h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_897_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M429.461,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.24 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.24C431.327,667.06,430.491,667.896,429.461,667.896z  M421.895,664.162h5.699v-49.506h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_896_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M419.193,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.45 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.45C421.06,667.06,420.224,667.896,419.193,667.896z  M411.628,664.162h5.699v-49.716h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_895_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M408.926,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.33 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.33C410.793,667.06,409.957,667.896,408.926,667.896z  M401.361,664.162h5.699v-49.596h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_894_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M398.659,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.802 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.802C400.526,667.06,399.69,667.896,398.659,667.896z  M391.094,664.162h5.699v-50.067h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_889_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M388.392,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C390.259,667.06,389.423,667.896,388.392,667.896 z M380.827,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_584_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M378.592,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C380.459,667.06,379.623,667.896,378.592,667.896 z M371.026,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_544_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M368.325,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-59.114 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v59.114C370.191,667.06,369.356,667.896,368.325,667.896 z M360.759,664.162h5.699v-55.38h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_543_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M358.058,667.896h-9.432c-1.031,0-1.867-0.836-1.867-1.867v-53.802 c0-1.031,0.836-1.867,1.867-1.867h9.432c1.031,0,1.867,0.836,1.867,1.867v53.802C359.924,667.06,359.089,667.896,358.058,667.896 z M350.492,664.162h5.699v-50.067h-5.699V664.162z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_542_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M327.4,667.392c-0.309,0-0.621-0.076-0.91-0.238l-8.232-4.603 c-0.432-0.241-0.751-0.644-0.885-1.121c-0.135-0.477-0.075-0.986,0.167-1.419l21.534-38.511c0.242-0.432,0.645-0.75,1.121-0.885 c0.476-0.136,0.987-0.075,1.419,0.167l8.232,4.603c0.9,0.503,1.221,1.641,0.718,2.54l-21.534,38.51 C328.689,667.047,328.054,667.392,327.4,667.392z M321.71,660.203l4.974,2.781l19.711-35.252l-4.974-2.781L321.71,660.203z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_540_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M300.465,575.273c-0.711,0-1.389-0.407-1.701-1.097l-24.39-53.848 c-0.204-0.451-0.221-0.965-0.047-1.429c0.174-0.463,0.526-0.838,0.977-1.042l8.592-3.892c0.937-0.425,2.045-0.01,2.47,0.93 l24.39,53.848c0.205,0.451,0.221,0.965,0.047,1.429c-0.174,0.463-0.526,0.838-0.977,1.042l-8.592,3.892 C300.984,575.219,300.723,575.273,300.465,575.273z M278.544,520.488l22.85,50.446l5.191-2.352l-22.85-50.446L278.544,520.488z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3924_",
    x: 257.104,
    y: 593.152,
    style: {
      fill: "#BEAD94"
    },
    width: 66.921,
    height: 103.291
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3918_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M325.281,701.796h-68.819c-2.41,0-4.364-1.954-4.364-4.364V591.524c0-2.41,1.954-4.364,4.364-4.364 h68.819c2.411,0,4.364,1.954,4.364,4.364v105.907C329.646,699.842,327.692,701.796,325.281,701.796z M260.827,693.067h60.09 v-97.179h-60.09V693.067z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3908_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M316.802,690.697h-51.568c-1.112,0-2.013-0.901-2.013-2.014V600c0-1.112,0.901-2.014,2.013-2.014 h51.568c1.112,0,2.013,0.901,2.013,2.014v88.684C318.815,689.796,317.914,690.697,316.802,690.697z M267.247,686.671h47.542 v-84.658h-47.542V686.671z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3864_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3884_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3892_",
    x: 276.562,
    y: 609.155,
    style: {
      fill: "#C1D38B"
    },
    width: 11.403,
    height: 79.558
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3891_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M287.965,690.304h-11.403c-0.879,0-1.591-0.712-1.591-1.591v-79.558 c0-0.879,0.712-1.591,1.591-1.591h11.403c0.879,0,1.591,0.712,1.591,1.591v79.558 C289.556,689.592,288.844,690.304,287.965,690.304z M278.153,687.122h8.221v-76.376h-8.221V687.122z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3875_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3883_",
    x: 265.327,
    y: 613.815,
    style: {
      fill: "#B76C65"
    },
    width: 10.735,
    height: 74.898
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3882_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M276.361,690.304h-10.735c-0.879,0-1.591-0.712-1.591-1.591v-74.898 c0-0.879,0.712-1.591,1.591-1.591h10.735c0.879,0,1.591,0.712,1.591,1.591v74.898 C277.952,689.592,277.239,690.304,276.361,690.304z M267.216,687.122h7.553v-71.717h-7.553V687.122z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3865_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3874_",
    x: 294.299,
    y: 618.259,
    transform: "matrix(0.9824 -0.1869 0.1869 0.9824 -116.831 67.4566)",
    style: {
      fill: "#F9F8F3"
    },
    width: 10.049,
    height: 70.106
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3866_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M300.937,690.277c-0.749,0-1.416-0.531-1.561-1.294l-13.103-68.87 c-0.079-0.415,0.01-0.844,0.247-1.192c0.237-0.35,0.604-0.59,1.018-0.669l9.872-1.878c0.865-0.159,1.697,0.402,1.86,1.266 l13.103,68.87c0.079,0.415-0.01,0.844-0.247,1.192c-0.237,0.35-0.604,0.59-1.018,0.669l-9.872,1.878 C301.136,690.268,301.036,690.277,300.937,690.277z M289.697,621.081l12.508,65.744l6.746-1.283l-12.508-65.744L289.697,621.081 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_586_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_647_",
    style: {
      fill: "#6D6D6D"
    },
    d: "M1016.151,914.867H791.624c0.006-0.166,0.032-0.328,0.032-0.495 c0-10.063-10.511-18.221-23.477-18.221H358.113c-12.966,0-23.477,8.158-23.477,18.221c0,0.167,0.027,0.329,0.032,0.495H102.315 c-10.202,0-18.473,6.419-18.473,14.337c0,7.918,8.27,14.337,18.473,14.337h123.25c-0.82,2.111-1.271,4.346-1.271,6.665l0,0 c0,12.747,13.314,23.08,29.738,23.08h623.708c16.424,0,29.737-10.333,29.737-23.08l0,0c0-2.319-0.452-4.554-1.271-6.665h109.946 c10.202,0,18.473-6.419,18.473-14.337C1034.624,921.286,1026.354,914.867,1016.151,914.867z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_637_",
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_638_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_639_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_640_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_641_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_642_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_643_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_644_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_645_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_646_",
    style: {
      fill: "#424243"
    },
    d: "M419.454,993.747H221.611c-1.834,0-3.334-1.5-3.334-3.335l0,0 c0-1.834,1.5-3.334,3.334-3.334h197.843c1.834,0,3.335,1.5,3.335,3.334l0,0 C422.788,992.247,421.288,993.747,419.454,993.747z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_627_",
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_628_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_629_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_630_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_631_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_632_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_633_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_634_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_635_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_636_",
    style: {
      fill: "#424243"
    },
    d: "M438.127,993.747h-4.891c-1.834,0-3.335-1.5-3.335-3.335l0,0 c0-1.834,1.501-3.334,3.335-3.334h4.891c1.834,0,3.334,1.5,3.334,3.334l0,0 C441.461,992.247,439.96,993.747,438.127,993.747z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_617_",
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_618_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_619_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_620_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_621_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_622_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_623_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_624_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_625_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_626_",
    style: {
      fill: "#424243"
    },
    d: "M604.181,1011.531H411.673c-1.956,0-3.557-1.6-3.557-3.557l0,0 c0-1.956,1.601-3.557,3.557-3.557h192.508c1.956,0,3.557,1.601,3.557,3.557l0,0 C607.738,1009.93,606.137,1011.531,604.181,1011.531z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_607_",
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_608_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_609_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_610_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_611_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_612_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_613_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_614_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_615_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_616_",
    style: {
      fill: "#424243"
    },
    d: "M625.966,1011.531h-8.892c-1.956,0-3.557-1.6-3.557-3.557l0,0 c0-1.956,1.601-3.557,3.557-3.557h8.892c1.956,0,3.557,1.601,3.557,3.557l0,0 C629.523,1009.93,627.922,1011.531,625.966,1011.531z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_597_",
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_598_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_599_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_600_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_601_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_602_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_603_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_604_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_605_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_606_",
    style: {
      fill: "#424243"
    },
    d: "M892.954,995.992H700.446c-1.956,0-3.557-1.601-3.557-3.557l0,0 c0-1.956,1.601-3.557,3.557-3.557h192.508c1.956,0,3.557,1.601,3.557,3.557l0,0 C896.51,994.391,894.91,995.992,892.954,995.992z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_587_",
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_588_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_589_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_590_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_591_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_592_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_593_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_594_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_595_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_596_",
    style: {
      fill: "#424243"
    },
    d: "M914.739,995.992h-8.892c-1.956,0-3.557-1.601-3.557-3.557l0,0 c0-1.956,1.601-3.557,3.557-3.557h8.892c1.956,0,3.557,1.601,3.557,3.557l0,0 C918.295,994.391,916.695,995.992,914.739,995.992z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_507_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_537_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B804C"
    },
    d: "M311.555,545.487c-2.513,4.968-8.302,7.097-10.093,6.191c-1.791-0.906-3.505-6.831-0.992-11.798 c2.513-4.968,7.032-7.739,10.093-6.191C313.624,535.237,314.068,540.519,311.555,545.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M302.552,552.509c-0.534,0-1-0.091-1.37-0.277c-1.122-0.568-2.081-2.467-2.443-4.837 c-0.24-1.568-0.405-4.667,1.178-7.796c1.267-2.503,3.067-4.559,5.07-5.787c2.097-1.286,4.176-1.526,5.856-0.677 c1.68,0.85,2.718,2.667,2.924,5.118c0.197,2.341-0.393,5.01-1.659,7.514C309.949,550.033,305.337,552.509,302.552,552.509z  M308.7,533.878c-0.947,0-1.993,0.333-3.064,0.99c-1.81,1.11-3.447,2.989-4.612,5.291c-1.427,2.82-1.275,5.627-1.059,7.049 c0.328,2.146,1.142,3.595,1.777,3.916c1.405,0.713,6.883-1.221,9.259-5.918c1.165-2.301,1.708-4.733,1.53-6.85 c-0.169-2.006-0.967-3.467-2.248-4.114C309.802,533.998,309.269,533.878,308.7,533.878z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_536_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B804C"
    },
    d: "M292.452,534.231c3.035,5.917,0.421,13.317-2.002,14.56c-2.423,1.243-9.959-0.95-12.995-6.867 c-3.035-5.917-2.139-12.436,2.003-14.56C283.599,525.24,289.417,528.314,292.452,534.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M288.746,549.731c-3.514,0-9.266-2.501-11.842-7.523c-3.186-6.212-2.167-13.118,2.271-15.396 c4.437-2.274,10.643,0.924,13.83,7.136l0,0c1.905,3.713,1.507,7.511,1.101,9.443c-0.605,2.875-1.928,5.211-3.372,5.952 C290.229,549.602,289.545,549.731,288.746,549.731z M282.325,527.309c-0.907,0-1.782,0.195-2.585,0.607 c-3.829,1.965-4.607,8.123-1.733,13.726c2.957,5.764,10.146,7.631,12.16,6.599c0.92-0.472,2.151-2.376,2.725-5.103 c0.373-1.772,0.74-5.25-0.991-8.622l0,0C289.629,530.086,285.745,527.309,282.325,527.309z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_535_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#6B804C"
    },
    cx: 294.72,
    cy: 557.83,
    rx: 11.977,
    ry: 15.261
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M294.72,573.711c-4.257,0-12.597-7.19-12.597-15.881c0-8.757,5.651-15.881,12.597-15.881 s12.597,7.124,12.597,15.881C307.317,566.521,298.977,573.711,294.72,573.711z M294.72,543.19 c-6.262,0-11.356,6.567-11.356,14.641c0,8.304,8.063,14.641,11.356,14.641c3.293,0,11.356-6.337,11.356-14.641 C306.077,549.757,300.982,543.19,294.72,543.19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_534_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M281.612,529.469c-0.224,0-0.439-0.121-0.55-0.333l-1.628-3.118 c-0.158-0.304-0.04-0.679,0.263-0.837c0.304-0.158,0.678-0.041,0.837,0.263l1.628,3.118c0.158,0.304,0.041,0.679-0.263,0.837 C281.807,529.446,281.709,529.469,281.612,529.469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_533_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M287.848,531.964c-0.067,0-0.136-0.011-0.203-0.034c-0.324-0.112-0.495-0.465-0.383-0.789 l1.403-4.054c0.112-0.323,0.467-0.496,0.789-0.383c0.324,0.112,0.495,0.465,0.383,0.789l-1.403,4.054 C288.345,531.803,288.105,531.964,287.848,531.964z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_532_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M276.933,536.174c-0.107,0-0.215-0.027-0.314-0.086l-3.898-2.295 c-0.295-0.174-0.393-0.554-0.22-0.849c0.172-0.296,0.554-0.395,0.849-0.22l3.898,2.295c0.295,0.174,0.393,0.554,0.22,0.849 C277.353,536.065,277.146,536.174,276.933,536.174z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_531_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M283.951,537.577c-0.207,0-0.409-0.104-0.527-0.292l-1.589-2.551 c-0.181-0.291-0.092-0.674,0.199-0.854c0.29-0.182,0.672-0.093,0.854,0.198l1.589,2.551c0.181,0.291,0.092,0.674-0.199,0.854 C284.176,537.547,284.063,537.577,283.951,537.577z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_530_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M278.494,542.41c-0.011,0-0.023,0-0.035-0.001l-2.837-0.156c-0.342-0.019-0.603-0.312-0.585-0.653 c0.018-0.342,0.301-0.62,0.653-0.585l2.837,0.156c0.342,0.019,0.604,0.312,0.585,0.653 C279.094,542.154,278.82,542.41,278.494,542.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_529_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M291.122,536.302c-0.115,0-0.232-0.032-0.335-0.099c-0.288-0.186-0.371-0.569-0.186-0.857 l1.559-2.423c0.186-0.287,0.57-0.369,0.857-0.186c0.288,0.186,0.371,0.569,0.186,0.857l-1.559,2.423 C291.525,536.201,291.326,536.302,291.122,536.302z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_528_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M283.95,544.125c-0.167,0-0.332-0.066-0.455-0.198l-1.589-1.715 c-0.233-0.252-0.218-0.643,0.033-0.877c0.25-0.233,0.643-0.219,0.876,0.033l1.589,1.715c0.233,0.252,0.218,0.644-0.033,0.877 C284.253,544.07,284.101,544.125,283.95,544.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_527_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M289.251,542.254c-0.271,0-0.52-0.179-0.596-0.452l-0.702-2.494 c-0.093-0.33,0.099-0.672,0.429-0.765c0.33-0.09,0.672,0.1,0.765,0.429l0.702,2.494c0.093,0.33-0.099,0.672-0.429,0.765 C289.363,542.246,289.307,542.254,289.251,542.254z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_526_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M306.194,536.797c-0.278,0-0.531-0.188-0.601-0.47l-0.728-2.918 c-0.083-0.333,0.119-0.669,0.452-0.752c0.33-0.082,0.669,0.119,0.751,0.451l0.728,2.918c0.083,0.333-0.119,0.669-0.452,0.752 C306.294,536.791,306.244,536.797,306.194,536.797z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_525_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M310.456,536.302c-0.276,0-0.528-0.186-0.6-0.466c-0.085-0.331,0.114-0.669,0.446-0.755 l3.742-0.964c0.331-0.088,0.67,0.113,0.755,0.446c0.086,0.331-0.114,0.669-0.446,0.755l-3.742,0.964 C310.56,536.296,310.507,536.302,310.456,536.302z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_524_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M307.495,541.007c-0.205,0-0.406-0.102-0.524-0.287c-0.184-0.289-0.098-0.673,0.191-0.856 l1.962-1.247c0.289-0.183,0.672-0.099,0.856,0.19c0.184,0.289,0.098,0.673-0.191,0.857l-1.962,1.247 C307.724,540.976,307.608,541.007,307.495,541.007z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_523_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M313.184,544.125c-0.046,0-0.093-0.005-0.14-0.016l-3.727-0.857 c-0.333-0.077-0.542-0.41-0.465-0.743c0.077-0.333,0.409-0.542,0.744-0.466l3.727,0.857c0.333,0.077,0.542,0.41,0.465,0.743 C313.722,543.931,313.466,544.125,313.184,544.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_522_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M303.661,543.268c-0.216,0-0.427-0.113-0.54-0.315l-1.624-2.884 c-0.169-0.299-0.063-0.677,0.236-0.845c0.299-0.169,0.677-0.063,0.844,0.235l1.624,2.884c0.168,0.299,0.063,0.677-0.236,0.845 C303.869,543.242,303.764,543.268,303.661,543.268z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_521_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M297.864,566.266c-0.117,0-0.235-0.033-0.34-0.103c-0.286-0.188-0.365-0.572-0.177-0.858 l2.769-4.21c0.188-0.286,0.573-0.365,0.859-0.177c0.286,0.188,0.365,0.572,0.177,0.858l-2.769,4.21 C298.263,566.167,298.065,566.266,297.864,566.266z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_519_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M310.456,549.747c-0.089,0-0.181-0.02-0.267-0.061l-4.262-2.035 c-0.309-0.148-0.44-0.518-0.292-0.827c0.148-0.309,0.518-0.438,0.827-0.292l4.262,2.035c0.309,0.147,0.44,0.518,0.293,0.827 C310.91,549.617,310.688,549.747,310.456,549.747z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_518_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M296.061,545.685c-0.03,0-0.06-0.002-0.09-0.007c-0.339-0.049-0.574-0.363-0.525-0.702 l0.676-4.678c0.049-0.338,0.367-0.572,0.703-0.525c0.339,0.049,0.574,0.363,0.525,0.702l-0.676,4.678 C296.628,545.462,296.363,545.685,296.061,545.685z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_517_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M286.132,553.481c-0.099,0-0.2-0.024-0.293-0.074l-3.771-2.026 c-0.302-0.162-0.415-0.538-0.253-0.84c0.163-0.302,0.539-0.416,0.84-0.252l3.771,2.026c0.302,0.162,0.415,0.538,0.253,0.84 C286.567,553.362,286.353,553.481,286.132,553.481z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_516_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M291.123,552.501c-0.198,0-0.394-0.095-0.513-0.271l-1.871-2.754 c-0.192-0.283-0.119-0.669,0.164-0.861c0.283-0.191,0.67-0.12,0.861,0.164l1.871,2.754c0.192,0.283,0.119,0.669-0.164,0.861 C291.364,552.466,291.243,552.501,291.123,552.501z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_515_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M299.206,556.911c-0.342,0-0.62-0.277-0.62-0.62v-3.431c0-0.343,0.278-0.62,0.62-0.62 c0.342,0,0.62,0.277,0.62,0.62v3.431C299.826,556.634,299.548,556.911,299.206,556.911z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_514_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M296.398,552.467c-0.019,0-0.037-0.001-0.056-0.003c-0.341-0.03-0.593-0.332-0.562-0.673 l0.338-3.737c0.031-0.341,0.335-0.601,0.673-0.562c0.341,0.03,0.593,0.332,0.562,0.673l-0.338,3.737 C296.986,552.225,296.715,552.467,296.398,552.467z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_513_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M304.376,555.976c-0.182,0-0.362-0.08-0.485-0.232c-0.214-0.268-0.17-0.658,0.097-0.872 l3.119-2.495c0.267-0.213,0.657-0.169,0.872,0.097c0.214,0.267,0.17,0.658-0.097,0.872l-3.119,2.495 C304.649,555.931,304.512,555.976,304.376,555.976z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_512_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M305.467,561.276c-0.194,0-0.385-0.091-0.506-0.262c-0.198-0.279-0.132-0.666,0.147-0.864 l2.859-2.026c0.28-0.197,0.665-0.133,0.864,0.147c0.198,0.279,0.132,0.666-0.147,0.864l-2.859,2.026 C305.716,561.239,305.591,561.276,305.467,561.276z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_511_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M293.822,562.056c-0.263,0-0.507-0.169-0.591-0.433l-1.141-3.605 c-0.103-0.327,0.078-0.676,0.404-0.778c0.327-0.102,0.674,0.078,0.778,0.403l1.141,3.605c0.103,0.327-0.078,0.676-0.404,0.778 C293.947,562.046,293.884,562.056,293.822,562.056z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_510_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M288.549,562.056c-0.291,0-0.55-0.205-0.608-0.502l-0.702-3.606 c-0.066-0.336,0.154-0.661,0.49-0.727c0.335-0.069,0.662,0.153,0.727,0.49l0.702,3.605c0.065,0.336-0.154,0.661-0.49,0.727 C288.628,562.052,288.589,562.056,288.549,562.056z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_509_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M284.247,560.263c-0.121,0-0.244-0.035-0.351-0.109l-2.636-1.813 c-0.282-0.194-0.353-0.58-0.159-0.862c0.194-0.281,0.581-0.354,0.862-0.159l2.636,1.813c0.282,0.194,0.354,0.58,0.159,0.862 C284.638,560.169,284.444,560.263,284.247,560.263z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_508_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF0F0"
    },
    d: "M304.518,587.947h-19.596c-0.689,0-1.277-0.501-1.386-1.182l-3.293-20.586 c-0.136-0.853,0.522-1.625,1.386-1.625h26.182c0.863,0,1.522,0.772,1.386,1.625l-3.293,20.586 C305.795,587.446,305.208,587.947,304.518,587.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M304.518,588.567h-19.596c-1,0-1.84-0.717-1.998-1.704l-3.293-20.586 c-0.094-0.585,0.073-1.181,0.458-1.632c0.385-0.452,0.946-0.711,1.54-0.711h26.182c0.593,0,1.154,0.259,1.54,0.71 c0.385,0.452,0.552,1.047,0.459,1.633l-3.293,20.586C306.358,587.851,305.518,588.567,304.518,588.567z M281.629,565.175 c-0.233,0-0.445,0.098-0.596,0.275c-0.151,0.177-0.214,0.401-0.177,0.631l3.293,20.587c0.061,0.382,0.386,0.659,0.773,0.659 h19.596c0.387,0,0.712-0.277,0.773-0.659l3.293-20.586c0.037-0.23-0.026-0.455-0.178-0.633c-0.151-0.177-0.363-0.274-0.596-0.274 H281.629z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_444_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_447_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_451_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEFEF"
    },
    d: "M372.61,668.515c-5.732,0-10.379,4.647-10.379,10.379c0,5.732,4.647,10.378,10.379,10.378 c5.732,0,10.378-4.647,10.378-10.378C382.989,673.161,378.342,668.515,372.61,668.515z M372.61,686.808 c-4.371,0-7.914-3.543-7.914-7.914c0-4.371,3.543-7.914,7.914-7.914c4.371,0,7.914,3.543,7.914,7.914 C380.524,683.264,376.981,686.808,372.61,686.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M372.61,690.273c-6.274,0-11.378-5.104-11.378-11.379c0-6.275,5.104-11.379,11.378-11.379 c6.274,0,11.379,5.104,11.379,11.379C383.989,685.168,378.884,690.273,372.61,690.273z M372.61,669.515 c-5.171,0-9.378,4.207-9.378,9.379c0,5.172,4.207,9.379,9.378,9.379c5.171,0,9.379-4.207,9.379-9.379 C381.989,673.722,377.781,669.515,372.61,669.515z M372.61,687.808c-4.915,0-8.914-3.999-8.914-8.914 c0-4.915,3.999-8.914,8.914-8.914c4.915,0,8.914,3.999,8.914,8.914C381.524,683.809,377.525,687.808,372.61,687.808z  M372.61,671.979c-3.813,0-6.914,3.102-6.914,6.914s3.102,6.914,6.914,6.914s6.914-3.102,6.914-6.914 S376.422,671.979,372.61,671.979z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_450_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.281,
    y: 656.167,
    style: {
      fill: "#EEEFEF"
    },
    width: 32.329,
    height: 41.195
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M372.61,698.862h-32.329c-0.829,0-1.5-0.672-1.5-1.5v-41.195c0-0.828,0.671-1.5,1.5-1.5h32.329 c0.829,0,1.5,0.672,1.5,1.5v41.195C374.11,698.19,373.439,698.862,372.61,698.862z M341.781,695.862h29.329v-38.195h-29.329 V695.862z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_449_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#618047"
    },
    d: "M340.281,672.4v12.987c3.586,0,6.493-2.907,6.493-6.493 C346.775,675.307,343.867,672.4,340.281,672.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M340.281,686.025c-0.353,0-0.639-0.286-0.639-0.639V672.4c0-0.352,0.286-0.639,0.639-0.639 c3.933,0,7.132,3.199,7.132,7.132C347.413,682.826,344.214,686.025,340.281,686.025z M340.92,673.073v11.641 c2.929-0.319,5.216-2.808,5.216-5.82S343.849,673.393,340.92,673.073z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_446_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M362.498,667.489c-0.036,0-0.073-0.003-0.11-0.01c-0.348-0.06-0.581-0.39-0.521-0.737 c0.776-4.494,1.355-11.269,0.211-12.263c-0.382-0.332-0.571-0.271-0.635-0.252c-0.516,0.161-1.036,1.334-1.225,2.075 c-0.087,0.342-0.439,0.542-0.776,0.462c-0.341-0.087-0.548-0.433-0.462-0.775c0.107-0.422,0.708-2.55,2.08-2.981 c0.428-0.134,1.094-0.154,1.855,0.506c2.098,1.82,0.543,11.519,0.211,13.444C363.072,667.271,362.802,667.489,362.498,667.489z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_445_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3EA5B"
    },
    d: "M362.976,673.707l-2.214-0.215c-1.053-0.102-1.824-1.039-1.721-2.093l0.328-3.367 c0.103-1.053,1.039-1.824,2.093-1.721l2.214,0.215c1.053,0.102,1.824,1.039,1.721,2.093l-0.328,3.367 C364.966,673.039,364.029,673.81,362.976,673.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M363.163,674.354c-0.082,0-0.165-0.004-0.249-0.012l-2.214-0.215 c-1.402-0.137-2.432-1.389-2.296-2.79l0.328-3.367c0.066-0.68,0.393-1.293,0.919-1.727c0.527-0.434,1.191-0.633,1.871-0.569 l2.214,0.216c0.679,0.066,1.292,0.393,1.725,0.92c0.434,0.526,0.636,1.19,0.57,1.869l-0.328,3.368 C365.575,673.366,364.461,674.354,363.163,674.354z M361.272,666.94c-0.295,0-0.578,0.101-0.809,0.291 c-0.263,0.216-0.426,0.523-0.46,0.862l-0.328,3.367c-0.068,0.701,0.447,1.327,1.148,1.396l2.213,0.215h0 c0.705,0.066,1.327-0.446,1.395-1.146l0.328-3.368c0.033-0.34-0.068-0.672-0.285-0.935c-0.217-0.264-0.523-0.427-0.863-0.46 l-2.214-0.216C361.356,666.942,361.314,666.94,361.272,666.94z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_860_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_862_",
    x: 236.998,
    y: 698.913,
    style: {
      fill: "#BEAD94"
    },
    width: 635.372,
    height: 11.287
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_861_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M872.37,713.146H236.998c-1.628,0-2.947-1.319-2.947-2.947v-11.286 c0-1.628,1.319-2.947,2.947-2.947H872.37c1.628,0,2.947,1.319,2.947,2.947v11.286 C875.317,711.827,873.998,713.146,872.37,713.146z M239.945,707.252h629.478v-5.392H239.945V707.252z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_849_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_856_",
    style: {
      fill: "#2D2E2A"
    },
    points: "835.532,930.152 826.815,930.184 777.891,709.855 786.472,709.647  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_855_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M826.596,933.685c-1.381,0-2.578-0.959-2.877-2.309l-48.923-220.329 c-0.191-0.86,0.013-1.761,0.556-2.455c0.543-0.694,1.369-1.108,2.25-1.13l8.581-0.208c0.023-0.001,0.048-0.001,0.072-0.001 c1.377,0,2.575,0.956,2.876,2.308l49.06,220.506c0.194,0.87-0.018,1.782-0.574,2.479c-0.557,0.697-1.399,1.104-2.292,1.107 l-8.718,0.031C826.603,933.685,826.6,933.685,826.596,933.685z M781.328,713.268l47.632,214.514l2.683-0.01l-47.738-214.566 L781.328,713.268z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_854_",
    style: {
      fill: "#2D2E2A"
    },
    points: "720.744,930.152 729.462,930.184 778.385,709.855 769.804,709.647  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_853_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M729.244,933.685c-0.004,0-0.007,0-0.011,0l-8.718-0.031c-0.893-0.003-1.735-0.41-2.292-1.107 c-0.557-0.697-0.769-1.609-0.574-2.479l49.06-220.506c0.306-1.376,1.523-2.384,2.948-2.307l8.582,0.208 c0.881,0.021,1.707,0.436,2.25,1.13c0.543,0.694,0.747,1.595,0.556,2.455l-48.924,220.329 C731.822,932.726,730.625,933.685,729.244,933.685z M724.198,927.771l2.683,0.01l47.633-214.514l-2.577-0.063L724.198,927.771z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_841_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_848_",
    style: {
      fill: "#2D2E2A"
    },
    points: "380.497,930.706 371.779,930.738 322.856,710.408 331.437,710.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_847_",
    style: {
      fill: "#2D2E2A"
    },
    points: "265.708,930.706 274.426,930.738 323.35,710.408 314.768,710.2  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_846_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M371.889,933.685c-1.381,0-2.578-0.959-2.878-2.309l-48.923-220.329 c-0.191-0.86,0.013-1.761,0.556-2.455c0.543-0.694,1.369-1.108,2.25-1.13l8.581-0.208c1.39-0.046,2.643,0.932,2.948,2.307 l49.06,220.506c0.194,0.87-0.017,1.782-0.574,2.479s-1.4,1.104-2.292,1.107l-8.718,0.031 C371.896,933.685,371.893,933.685,371.889,933.685z M326.62,713.268l47.632,214.514l2.683-0.01l-47.739-214.566L326.62,713.268z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_845_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M274.536,933.685c-0.003,0-0.007,0-0.011,0l-8.718-0.031c-0.892-0.003-1.735-0.41-2.292-1.107 c-0.557-0.697-0.768-1.609-0.574-2.479l49.06-220.506c0.306-1.376,1.564-2.386,2.948-2.307l8.581,0.208 c0.881,0.021,1.707,0.436,2.25,1.13c0.543,0.694,0.747,1.595,0.556,2.455l-48.923,220.329 C277.114,932.726,275.918,933.685,274.536,933.685z M269.491,927.771l2.683,0.01l47.632-214.514l-2.576-0.063L269.491,927.771z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1219_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1244_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1246_",
    style: {
      fill: "#F4F5F5"
    },
    d: "M746.972,685.021H584.228c-4.504,0-8.189-3.685-8.189-8.189v-98.26 c0-4.504,3.685-8.189,8.189-8.189h162.743c4.504,0,8.189,3.685,8.189,8.189v98.26 C755.16,681.336,751.475,685.021,746.972,685.021z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1245_",
    style: {
      fill: "#F4F5F5"
    },
    d: "M746.972,685.021H584.228c-4.504,0-8.189-3.685-8.189-8.189v-98.26 c0-4.504,3.685-8.189,8.189-8.189h162.743c4.504,0,8.189,3.685,8.189,8.189v98.26 C755.16,681.336,751.475,685.021,746.972,685.021z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1241_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1243_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M747.55,686.759H584.807c-5.473,0-9.926-4.453-9.926-9.926v-98.26 c0-5.474,4.453-9.927,9.926-9.927H747.55c5.474,0,9.927,4.453,9.927,9.927v98.26 C757.477,682.306,753.024,686.759,747.55,686.759z M584.807,572.121c-3.558,0-6.451,2.895-6.451,6.452v98.26 c0,3.558,2.893,6.451,6.451,6.451H747.55c3.558,0,6.452-2.894,6.452-6.451v-98.26c0-3.558-2.895-6.452-6.452-6.452H584.807z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1242_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M747.55,686.759H584.807c-5.473,0-9.926-4.453-9.926-9.926v-98.26 c0-5.474,4.453-9.927,9.926-9.927H747.55c5.474,0,9.927,4.453,9.927,9.927v98.26 C757.477,682.306,753.024,686.759,747.55,686.759z M584.807,572.121c-3.558,0-6.451,2.895-6.451,6.452v98.26 c0,3.558,2.893,6.451,6.451,6.451H747.55c3.558,0,6.452-2.894,6.452-6.451v-98.26c0-3.558-2.895-6.452-6.452-6.452H584.807z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1238_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1240_",
    style: {
      fill: "#F4F5F5"
    },
    d: "M741.181,677.88H591.563c-4.019,0-7.308-3.289-7.308-7.308v-84.966 c0-4.02,3.289-7.308,7.308-7.308h149.619c4.02,0,7.308,3.289,7.308,7.308v84.966C748.49,674.591,745.201,677.88,741.181,677.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1239_",
    style: {
      fill: "#F4F5F5"
    },
    d: "M741.181,677.88H591.563c-4.019,0-7.308-3.289-7.308-7.308v-84.966 c0-4.02,3.289-7.308,7.308-7.308h149.619c4.02,0,7.308,3.289,7.308,7.308v84.966C748.49,674.591,745.201,677.88,741.181,677.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1235_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1237_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M741.181,678.459H591.562c-4.668,0-8.466-3.798-8.466-8.466v-84.967 c0-4.668,3.798-8.466,8.466-8.466h149.619c4.669,0,8.467,3.798,8.467,8.466v84.967 C749.648,674.661,745.85,678.459,741.181,678.459z M591.562,578.877c-3.391,0-6.149,2.759-6.149,6.149v84.967 c0,3.391,2.759,6.149,6.149,6.149h149.619c3.392,0,6.15-2.759,6.15-6.149v-84.967c0-3.391-2.759-6.149-6.15-6.149H591.562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1236_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M741.181,678.459H591.562c-4.668,0-8.466-3.798-8.466-8.466v-84.967 c0-4.668,3.798-8.466,8.466-8.466h149.619c4.669,0,8.467,3.798,8.467,8.466v84.967 C749.648,674.661,745.85,678.459,741.181,678.459z M591.562,578.877c-3.391,0-6.149,2.759-6.149,6.149v84.967 c0,3.391,2.759,6.149,6.149,6.149h149.619c3.392,0,6.15-2.759,6.15-6.149v-84.967c0-3.391-2.759-6.149-6.15-6.149H591.562z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1234_",
    x: 576.645,
    y: 686.885,
    style: {
      fill: "#C5C5C5"
    },
    width: 177.377,
    height: 9.587
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1233_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M754.408,698.159H577.031c-0.904,0-1.638-0.733-1.638-1.638v-9.251 c0-0.904,0.733-1.638,1.638-1.638h177.377c0.904,0,1.638,0.733,1.638,1.638v9.251 C756.045,697.426,755.312,698.159,754.408,698.159z M578.669,694.884H752.77v-5.976H578.669V694.884z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1232_",
    x: 594.195,
    y: 593.558,
    style: {
      fill: "#C1D38B"
    },
    width: 145.1,
    height: 8.106
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1231_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M740.577,602.946H592.913v-10.671h147.664V602.946z M595.477,600.382h142.535v-5.542H595.477 V600.382z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1230_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M740.594,678.602H592.965V600.42h147.629V678.602z M595.454,676.114h142.652v-73.206H595.454 V676.114z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1229_",
    transform: "matrix(0.8022 -0.597 0.597 0.8022 -253.8342 502.7228)",
    style: {
      fill: "#C1D38B"
    },
    cx: 631.846,
    cy: 634.475,
    rx: 22.196,
    ry: 22.196
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B76C65"
    },
    points: "647.286,618.07 632.425,634.475 654.621,634.475  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1227_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M631.846,658.023c-12.878,0-23.355-10.477-23.355-23.354c0-12.877,10.477-23.354,23.355-23.354 c12.877,0,23.353,10.477,23.353,23.354C655.2,647.546,644.723,658.023,631.846,658.023z M631.846,613.631 c-11.601,0-21.038,9.438-21.038,21.037c0,11.601,9.438,21.038,21.038,21.038c11.6,0,21.037-9.438,21.037-21.038 C652.883,623.068,643.446,613.631,631.846,613.631z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1226_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M654.042,635.826h-22.195c-0.458,0-0.873-0.27-1.059-0.688c-0.185-0.419-0.107-0.908,0.2-1.247 l14.861-16.405c0.431-0.474,1.162-0.508,1.636-0.081c0.475,0.43,0.511,1.162,0.081,1.636l-13.108,14.47h19.584 c0.64,0,1.158,0.518,1.158,1.158C655.2,635.308,654.681,635.826,654.042,635.826z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1225_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M722.424,647.565h-50.375c-0.319,0-0.579-0.26-0.579-0.579v-9.844c0-0.319,0.26-0.579,0.579-0.579 h50.375c0.319,0,0.579,0.26,0.579,0.579v9.844C723.003,647.305,722.744,647.565,722.424,647.565z M672.628,646.406h49.217v-8.686 h-49.217V646.406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1224_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M722.424,637.432h-50.375c-0.319,0-0.579-0.26-0.579-0.579v-9.844c0-0.319,0.26-0.579,0.579-0.579 h50.375c0.319,0,0.579,0.26,0.579,0.579v9.844C723.003,637.172,722.744,637.432,722.424,637.432z M672.628,636.273h49.217v-8.685 h-49.217V636.273z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1223_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M722.424,622.956h-50.375c-0.319,0-0.579-0.26-0.579-0.579v-9.844c0-0.319,0.26-0.579,0.579-0.579 h50.375c0.319,0,0.579,0.26,0.579,0.579v9.844C723.003,622.696,722.744,622.956,722.424,622.956z M672.628,621.798h49.217v-8.686 h-49.217V621.798z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1222_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M722.424,657.118h-50.375c-0.319,0-0.579-0.26-0.579-0.579v-9.844c0-0.319,0.26-0.579,0.579-0.579 h50.375c0.319,0,0.579,0.26,0.579,0.579v9.844C723.003,656.858,722.744,657.118,722.424,657.118z M672.628,655.96h49.217v-8.686 h-49.217V655.96z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1221_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M722.424,666.672h-50.375c-0.319,0-0.579-0.26-0.579-0.579v-9.844c0-0.319,0.26-0.579,0.579-0.579 h50.375c0.319,0,0.579,0.26,0.579,0.579v9.844C723.003,666.412,722.744,666.672,722.424,666.672z M672.628,665.514h49.217v-8.686 h-49.217V665.514z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1220_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M722.424,676.226h-50.375c-0.319,0-0.579-0.26-0.579-0.579v-9.843c0-0.319,0.26-0.579,0.579-0.579 h50.375c0.319,0,0.579,0.26,0.579,0.579v9.843C723.003,675.966,722.744,676.226,722.424,676.226z M672.628,675.067h49.217v-8.685 h-49.217V675.067z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_395_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_955_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M575.768,806.786c-3.898,0-8.092-0.417-12.622-1.25c-19.348-3.557-29.966-14.593-29.897-31.076 c0.056-13.201,5.37-25.872,10.508-38.125c1.486-3.544,2.89-6.891,4.171-10.251c5.132-13.459,10.083-29.513,7.9-46.525 c-0.214-1.671-0.297-3.442-0.384-5.318c-0.217-4.673-0.442-9.506-2.753-12.346l3.181-2.588c3.163,3.889,3.432,9.655,3.668,14.742 c0.084,1.791,0.162,3.482,0.355,4.988c2.299,17.912-2.823,34.573-8.136,48.508c-1.305,3.423-2.788,6.958-4.221,10.376 c-4.984,11.883-10.137,24.171-10.189,36.557c-0.042,10.096,4.528,22.979,26.539,27.025c9.91,1.823,18.007,1.544,24.749-0.859 c13.21-4.701,18.501-16.192,17.156-37.255l4.092-0.262c0.919,14.4-0.141,34.356-19.873,41.38 C585.741,806.027,581.024,806.786,575.768,806.786z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_954_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C739F"
    },
    d: "M492.593,753.33c-13.672,0-24.755,12.596-24.755,26.268v133.979l0,0h49.51h0l0.756-128.625 C518.104,771.279,527.678,751.692,492.593,753.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M520.065,916.31h-54.961V779.597c0-15.697,12.551-28.962,27.422-29.001 c12.543-0.576,20.819,1.481,25.319,6.29c5.28,5.643,4.365,13.717,3.558,20.84c-0.292,2.571-0.567,5-0.567,7.226L520.065,916.31z  M470.571,910.843h44.059l0.74-125.907c0-2.518,0.306-5.217,0.602-7.825c0.74-6.526,1.438-12.69-2.117-16.489 c-3.302-3.527-10.408-5.063-21.134-4.562l-0.127,0.003c-11.731,0-22.022,10.997-22.022,23.534V910.843z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_953_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C739F"
    },
    d: "M615.007,754.127c13.615,1.242,23.509,14.792,22.267,28.407l-12.167,133.425l0,0l-49.305-4.496h0 l10.928-128.162C587.972,769.686,580.216,749.31,615.007,754.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M627.581,918.93l-54.732-4.991l11.158-130.87c0.203-2.232,0.149-4.675,0.093-7.262 c-0.157-7.168-0.335-15.292,5.436-20.432c4.92-4.38,13.354-5.676,25.785-3.965c7.243,0.68,13.833,4.448,18.562,10.617 c4.548,5.934,6.777,13.498,6.115,20.755L627.581,918.93z M578.756,908.987l43.877,4.001l11.918-130.702 c0.539-5.905-1.287-12.077-5.009-16.933c-3.803-4.962-9.053-7.981-14.783-8.504l-0.127-0.015 c-10.633-1.473-17.854-0.589-21.462,2.623c-3.886,3.461-3.749,9.662-3.605,16.229c0.058,2.625,0.117,5.339-0.112,7.862 L578.756,908.987z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_952_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BABD"
    },
    d: "M525.097,939.925H462.49c-1.455,0-2.635-1.18-2.635-2.635v-1.912 c0-8.499,6.89-15.389,15.389-15.389h37.099c8.499,0,15.389,6.89,15.389,15.389v1.912 C527.732,938.745,526.552,939.925,525.097,939.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454446"
    },
    d: "M525.097,942.673H462.49c-2.969,0-5.384-2.414-5.384-5.383v-1.912 c0-10.001,8.137-18.137,18.138-18.137h37.1c10.001,0,18.137,8.136,18.137,18.137v1.912 C530.481,940.259,528.065,942.673,525.097,942.673z M462.603,937.177h62.38v-1.799c0-6.97-5.67-12.641-12.64-12.641h-37.1 c-6.97,0-12.641,5.671-12.641,12.641V937.177z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_951_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BABD"
    },
    d: "M630.203,941.248h-62.048c-1.61,0-2.915-1.305-2.915-2.915l0,0 c0-9.401,7.621-20.046,17.021-20.046l33.835,3.025c9.401,0,17.021,7.621,17.021,17.021l0,0 C633.117,939.943,631.813,941.248,630.203,941.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454446"
    },
    d: "M630.203,943.996h-62.048c-3.123,0-5.663-2.54-5.663-5.663c0-10.541,8.636-22.794,19.77-22.794 c0.082,0,0.163,0.003,0.245,0.011l33.717,3.014c10.843,0.069,19.643,8.911,19.643,19.77 C635.866,941.456,633.326,943.996,630.203,943.996z M582.146,921.036c-7.852,0.092-14.158,9.5-14.158,17.297 c0,0.092,0.075,0.167,0.167,0.167h62.048c0.092,0,0.167-0.075,0.167-0.167c0-7.87-6.403-14.273-14.273-14.273 c-0.082,0-0.163-0.003-0.245-0.011L582.146,921.036z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_950_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB79D"
    },
    d: "M688.721,695.591l4.102-2.761c5.296-3.565,6.699-10.747,3.134-16.043l-47.742-70.923 c-3.565-5.296-10.748-6.699-16.043-3.134l-4.102,2.761c-5.296,3.565-6.699,10.748-3.134,16.043l47.742,70.923 C676.242,697.753,683.425,699.156,688.721,695.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M682.297,700.593c-0.939,0-1.885-0.091-2.827-0.275c-3.824-0.747-7.128-2.938-9.303-6.17 l-47.741-70.923c-2.176-3.232-2.963-7.118-2.216-10.941c0.747-3.824,2.938-7.128,6.17-9.303l4.102-2.762 c6.67-4.491,15.753-2.717,20.245,3.955l47.741,70.923c4.491,6.672,2.717,15.754-3.954,20.244l-4.103,2.762 C687.975,699.742,685.169,700.593,682.297,700.593z M638.613,603.789c-1.639,0-3.293,0.47-4.751,1.451l-4.102,2.762 c-1.891,1.272-3.173,3.205-3.609,5.441c-0.438,2.237,0.023,4.51,1.296,6.4l47.741,70.923c1.272,1.891,3.205,3.173,5.442,3.609 c2.233,0.44,4.51-0.021,6.399-1.295l0,0l4.102-2.762c3.902-2.627,4.94-7.939,2.313-11.842l-47.741-70.923 C644.059,605.11,641.359,603.789,638.613,603.789z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_746_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_945_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M588.821,592.977c14.311-13.23,31.451-15.071,44.856-6.159 c6.729,4.475,12.685,10.212,17.502,17.163l34.311,49.507l-36.569,25.337L588.821,592.977z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_944_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M620.979,635.337l28.549,40.78l33.205-23.007l-33.24-47.962 c-4.585-6.616-10.316-12.238-17.034-16.705c-11.234-7.471-24.98-6.727-37.064,1.647c-1.338,0.927-2.657,1.949-3.948,3.063 l2.659,3.798c0.597,0.853,0.324,2.073-0.61,2.72l0,0c-0.928,0.643-2.158,0.478-2.752-0.37l-3.605-5.149 c-0.526-0.751-0.387-1.826,0.345-2.505c14.723-13.63,32.899-16.104,47.41-6.455c7.087,4.715,13.134,10.644,17.97,17.621 l34.311,49.507c0.284,0.41,0.378,0.926,0.263,1.435c-0.115,0.509-0.432,0.969-0.878,1.278l-36.569,25.337 c-0.928,0.643-2.157,0.478-2.752-0.37l-29.622-42.313c-0.597-0.853-0.324-2.073,0.61-2.72l0,0 C619.155,634.324,620.385,634.489,620.979,635.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M648.763,681.736c-0.909,0.001-1.785-0.406-2.324-1.175l-29.623-42.314 c-0.421-0.601-0.58-1.341-0.448-2.084c0.143-0.796,0.617-1.524,1.302-2c1.367-0.949,3.211-0.673,4.11,0.612l0.001,0.001 l27.99,39.982l31.601-21.896l-32.683-47.156c-4.517-6.517-10.159-12.052-16.771-16.449c-10.738-7.14-24.186-6.528-35.965,1.637 c-1.082,0.751-2.152,1.566-3.192,2.429l2.147,3.067c0.422,0.603,0.58,1.344,0.447,2.087c-0.143,0.795-0.616,1.523-1.302,1.997 c-1.365,0.947-3.212,0.671-4.109-0.612l-3.605-5.15c-0.808-1.153-0.601-2.78,0.481-3.783 c15.078-13.957,33.708-16.466,48.617-6.552c7.192,4.785,13.326,10.801,18.231,17.879l34.311,49.506 c0.438,0.632,0.588,1.436,0.413,2.208c-0.17,0.751-0.622,1.414-1.274,1.866l-36.57,25.337 C650,681.554,649.375,681.736,648.763,681.736z M619.461,635.552c-0.225,0-0.465,0.071-0.677,0.219 c-0.261,0.181-0.44,0.449-0.49,0.736c-0.029,0.16-0.03,0.398,0.124,0.618l29.623,42.315c0.283,0.403,0.908,0.463,1.392,0.126 l36.57-25.337c0.244-0.17,0.42-0.422,0.481-0.69c0.055-0.242,0.015-0.478-0.112-0.662L652.06,603.37 c-4.764-6.875-10.721-12.717-17.707-17.364c-14.119-9.388-31.825-6.953-46.204,6.358c-0.368,0.342-0.458,0.869-0.208,1.227 l3.604,5.149c0.285,0.405,0.91,0.464,1.394,0.127c0.261-0.181,0.439-0.448,0.49-0.734c0.029-0.161,0.031-0.398-0.124-0.62 l-3.166-4.523l0.67-0.578c1.3-1.12,2.655-2.172,4.028-3.125c12.467-8.639,26.732-9.259,38.164-1.658 c6.818,4.535,12.638,10.242,17.295,16.963l33.798,48.766l-34.81,24.118l-29.107-41.578 C620.018,635.67,619.751,635.552,619.461,635.552z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_399_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB79D"
    },
    d: "M415.432,693.639l-4.102-2.761c-5.296-3.565-6.699-10.748-3.134-16.043l47.742-70.923 c3.565-5.296,10.748-6.699,16.043-3.134l4.102,2.761c5.296,3.565,6.699,10.748,3.134,16.043l-47.742,70.923 C427.91,695.801,420.727,697.204,415.432,693.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M421.856,698.641c-2.872,0-5.679-0.852-8.114-2.491l-4.102-2.761 c-3.232-2.175-5.423-5.479-6.17-9.303c-0.747-3.824,0.04-7.71,2.216-10.941l47.741-70.924c4.491-6.671,13.572-8.444,20.244-3.954 l4.103,2.762c3.231,2.175,5.423,5.479,6.17,9.303c0.747,3.823-0.04,7.709-2.216,10.941l-47.742,70.923 c-2.175,3.232-5.479,5.423-9.303,6.17C423.741,698.55,422.795,698.641,421.856,698.641z M465.539,601.837 c-2.747,0-5.445,1.32-7.091,3.765l-47.741,70.924c-1.273,1.891-1.733,4.163-1.296,6.399c0.437,2.237,1.719,4.17,3.609,5.442 l4.102,2.761h0c1.891,1.272,4.164,1.731,6.4,1.296c2.236-0.437,4.169-1.719,5.441-3.609l47.742-70.923 c1.272-1.891,1.733-4.163,1.296-6.4c-0.437-2.236-1.719-4.169-3.609-5.441l-4.102-2.762 C468.832,602.307,467.177,601.837,465.539,601.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_396_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_398_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M515.331,591.024c-14.311-13.23-31.451-15.071-44.856-6.159 c-6.729,4.474-12.685,10.212-17.502,17.163l-34.311,49.507l36.569,25.337L515.331,591.024z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_397_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M483.173,633.385l-28.549,40.78l-33.205-23.007l33.24-47.962 c4.585-6.616,10.316-12.238,17.034-16.705c11.234-7.471,24.98-6.727,37.064,1.647c1.338,0.927,2.657,1.949,3.948,3.063 l-2.659,3.798c-0.597,0.853-0.324,2.073,0.61,2.72l0,0c0.928,0.643,2.158,0.478,2.752-0.37l3.605-5.149 c0.526-0.751,0.387-1.826-0.345-2.505c-14.723-13.63-32.899-16.104-47.41-6.455c-7.087,4.715-13.134,10.644-17.97,17.621 l-34.311,49.507c-0.284,0.41-0.378,0.926-0.263,1.435c0.115,0.509,0.432,0.969,0.878,1.278l36.569,25.337 c0.928,0.643,2.157,0.477,2.752-0.37l29.622-42.313c0.597-0.853,0.324-2.073-0.61-2.72l0,0 C484.997,632.371,483.767,632.537,483.173,633.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M455.388,679.784c-0.61,0-1.235-0.184-1.784-0.563l-36.569-25.337 c-0.652-0.452-1.104-1.114-1.275-1.866c-0.175-0.771-0.024-1.576,0.413-2.207l34.312-49.508 c4.905-7.078,11.039-13.093,18.231-17.878c14.914-9.915,33.541-7.405,48.616,6.552c1.083,1.003,1.291,2.63,0.482,3.784 l-3.605,5.148c-0.901,1.286-2.744,1.562-4.111,0.613c-0.685-0.475-1.16-1.204-1.302-2c-0.133-0.742,0.027-1.483,0.449-2.085 l2.146-3.066c-1.043-0.867-2.113-1.682-3.191-2.429c-11.782-8.164-25.227-8.778-35.965-1.637 c-6.611,4.397-12.254,9.931-16.771,16.448l-32.683,47.157l31.601,21.896l27.991-39.982c0.9-1.286,2.743-1.562,4.11-0.613 c0.684,0.474,1.159,1.202,1.301,1.997c0.133,0.743-0.026,1.484-0.448,2.087l-29.622,42.313 C457.175,679.377,456.298,679.784,455.388,679.784z M488.19,578.401c-6.412,0-12.693,1.863-18.392,5.652 c-6.985,4.647-12.943,10.489-17.707,17.364l-34.311,49.507c-0.128,0.184-0.168,0.419-0.112,0.661 c0.06,0.269,0.236,0.521,0.481,0.691l36.569,25.337c0.483,0.334,1.108,0.277,1.393-0.128l29.622-42.312 c0.155-0.222,0.153-0.46,0.125-0.621c-0.051-0.286-0.23-0.554-0.49-0.734c-0.483-0.333-1.109-0.278-1.394,0.127l-29.107,41.578 l-34.81-24.118l33.798-48.767c4.659-6.721,10.478-12.428,17.296-16.962c11.43-7.602,25.697-6.982,38.163,1.658 c1.368,0.947,2.724,1.999,4.029,3.126l0.669,0.577l-3.165,4.521c-0.155,0.222-0.153,0.459-0.125,0.619 c0.051,0.287,0.23,0.556,0.491,0.736c0.483,0.334,1.109,0.278,1.394-0.128l3.605-5.148c0.25-0.357,0.16-0.885-0.209-1.227 C507.427,582.473,497.667,578.401,488.19,578.401z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_745_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB79D"
    },
    d: "M511.129,738.753c-0.466,10.119-8.719,17.959-18.433,17.512 c-6.823-0.314-12.808-4.825-15.372-11.096c-3.381-8.27,0.207-16.045,4.494-23.177c2.027-3.373,4.301-6.962,7.955-8.423 c0.247,2.223,0.323,4.465,0.227,6.699c5.918-0.825,10.93-0.192,15.457,4.125C509.333,728.089,511.375,733.419,511.129,738.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M493.497,759.017c-0.308,0-0.616-0.007-0.926-0.021c-7.768-0.357-14.746-5.379-17.776-12.793 c-3.813-9.327-0.004-17.825,4.681-25.619c1.95-3.245,4.621-7.689,9.283-9.553c0.792-0.317,1.688-0.246,2.42,0.193 c0.732,0.439,1.217,1.194,1.311,2.043c0.146,1.319,0.237,2.651,0.27,3.985c4.548-0.234,9.795,0.596,14.584,5.162 c4.429,4.224,6.804,10.225,6.516,16.465c-0.258,5.602-2.6,10.777-6.596,14.573C503.466,757.06,498.608,759.017,493.497,759.017z  M487.305,718.79c-1.104,1.29-2.107,2.885-3.144,4.609c-4.566,7.598-7.046,14.031-4.306,20.734c2.228,5.45,7.318,9.14,12.968,9.4 c3.94,0.162,7.738-1.255,10.676-4.045c2.967-2.819,4.708-6.677,4.9-10.862l0,0c0.211-4.59-1.594-9.172-4.829-12.256 c-3.402-3.244-7.223-4.229-13.192-3.396c-0.807,0.11-1.616-0.139-2.216-0.684c-0.6-0.546-0.927-1.33-0.893-2.141 C487.289,719.698,487.301,719.244,487.305,718.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_744_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB79D"
    },
    d: "M595.76,738.753c0.466,10.119,8.719,17.959,18.433,17.512c6.823-0.314,12.808-4.825,15.372-11.096 c3.381-8.27-0.207-16.045-4.494-23.177c-2.027-3.373-4.301-6.962-7.955-8.423c-0.247,2.223-0.323,4.465-0.227,6.699 c-5.918-0.825-10.93-0.192-15.457,4.125C597.557,728.089,595.514,733.419,595.76,738.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M613.393,759.017c-5.112,0-9.97-1.956-13.768-5.565c-3.995-3.796-6.338-8.972-6.596-14.573 c-0.288-6.24,2.087-12.241,6.516-16.465c4.788-4.566,10.035-5.397,14.584-5.162c0.033-1.335,0.123-2.667,0.27-3.985 c0.095-0.849,0.579-1.604,1.312-2.043c0.734-0.439,1.628-0.511,2.42-0.193c4.662,1.863,7.333,6.308,9.283,9.553 c4.685,7.794,8.495,16.292,4.682,25.619c-3.03,7.413-10.008,12.436-17.776,12.793 C614.009,759.01,613.701,759.017,613.393,759.017z M612.819,722.694c-3.96,0-6.857,1.156-9.5,3.677 c-3.235,3.085-5.04,7.666-4.828,12.256l0,0c0.193,4.185,1.934,8.043,4.9,10.862c2.938,2.79,6.729,4.211,10.676,4.045 c5.649-0.261,10.74-3.95,12.968-9.4c2.74-6.703,0.261-13.137-4.307-20.734c-1.036-1.725-2.04-3.319-3.143-4.609 c0.005,0.454,0.017,0.908,0.036,1.36c0.034,0.81-0.293,1.595-0.893,2.141c-0.6,0.545-1.411,0.796-2.216,0.684 C615.18,722.789,613.956,722.694,612.819,722.694z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_742_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A6A8"
    },
    d: "M590.38,762.474l-23.998-53.219c-1.599-3.546-0.006-7.756,3.54-9.355l24.393-11 c3.546-1.599,7.756-0.006,9.355,3.54l23.998,53.219c1.599,3.546,0.006,7.756-3.54,9.355l-24.393,11 C596.189,767.613,591.979,766.02,590.38,762.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M596.848,769.373c-1.175,0-2.354-0.214-3.488-0.643c-2.455-0.929-4.398-2.752-5.472-5.133 l-23.998-53.219c-2.223-4.93-0.021-10.748,4.909-12.971l24.393-11c4.932-2.221,10.748-0.021,12.972,4.909l23.997,53.219 c1.073,2.381,1.153,5.044,0.224,7.499c-0.929,2.455-2.751,4.398-5.132,5.473l-24.394,10.999 C599.579,769.083,598.216,769.373,596.848,769.373z M597.216,691.008c-0.596,0-1.2,0.123-1.777,0.384l-24.393,11 c-2.182,0.983-3.155,3.558-2.172,5.739l23.998,53.219c0,0,0,0,0,0.001c0.473,1.049,1.333,1.854,2.423,2.266 c1.088,0.412,2.266,0.379,3.316-0.095l24.393-10.999c1.05-0.473,1.855-1.334,2.267-2.423c0.412-1.09,0.379-2.268-0.095-3.316 l-23.997-53.219C600.456,691.96,598.872,691.008,597.216,691.008z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_741_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M552.153,662.65c-18.559,0-33.124-6.191-43.29-18.402c-7.17-8.613-15.892-25.098-16.72-54.713 c-0.492-17.575,1.997-31.309,2.103-31.885l4.032,0.743c-0.101,0.547-9.783,54.991,13.742,83.238 c9.35,11.227,22.852,16.919,40.132,16.919c17.315,0,30.91-5.715,40.409-16.986c23.846-28.293,14.835-82.65,14.741-83.194 l4.041-0.695c0.099,0.576,2.414,14.294,1.707,31.855c-0.658,16.33-4.202,39.071-17.354,54.677 C585.383,656.445,570.733,662.65,552.153,662.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_735_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_739_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A6A8"
    },
    d: "M564.184,756.094h-33.269c-4.084,0-7.394-3.31-7.394-7.394v-60.521 c0-4.084,3.31-7.394,7.394-7.394h33.269c4.084,0,7.394,3.31,7.394,7.394V748.7C571.578,752.784,568.268,756.094,564.184,756.094 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M564.184,758.144h-33.269c-5.208,0-9.445-4.236-9.445-9.443V688.18 c0-5.208,4.237-9.444,9.445-9.444h33.269c5.208,0,9.444,4.236,9.444,9.444V748.7 C573.628,753.907,569.392,758.144,564.184,758.144z M530.916,682.835c-2.947,0-5.344,2.397-5.344,5.345V748.7 c0,2.946,2.397,5.344,5.344,5.344h33.269c2.947,0,5.345-2.397,5.345-5.344V688.18c0-2.947-2.397-5.345-5.345-5.345H530.916z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_736_",
    style: {
      fill: "#59595B"
    },
    d: "M557.562,711.041c-6.526,0-9.894-4.877-10.132-9.932 c-5.492,0.065-9.925,4.531-9.925,10.039c0,5.547,4.497,10.045,10.045,10.045c5.548,0,10.045-4.497,10.045-10.045 c0-0.037-0.005-0.072-0.006-0.108C557.579,711.039,557.571,711.041,557.562,711.041z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_733_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#475C7A"
    },
    d: "M609.589,792.687c-39.215-12.557-77.618-13.53-115.004,0c-15.293,0-27.69-16.621-27.69-37.124v0 c0-20.503,12.397-37.124,27.69-37.124h115.004c15.293,0,27.69,16.621,27.69,37.124v0 C637.279,776.066,624.882,792.687,609.589,792.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M609.589,795.421h-0.427l-0.407-0.13c-39.898-12.776-77.998-12.788-113.24-0.033l-0.451,0.163 h-0.479c-16.775,0-30.423-17.88-30.423-39.857c0-21.978,13.648-39.857,30.423-39.857h115.004 c16.775,0,30.424,17.88,30.424,39.857C640.013,777.541,626.365,795.421,609.589,795.421z M550.336,780.227 c19.36,0,39.288,3.239,59.665,9.722c13.572-0.305,24.546-15.612,24.546-34.386c0-18.963-11.195-34.391-24.957-34.391H494.585 c-13.761,0-24.957,15.428-24.957,34.391c0,18.751,10.946,34.045,24.495,34.385C512.196,783.468,530.981,780.227,550.336,780.227z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_732_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M565.364,758.222h-26.422c-41.242,0-74.986-33.744-74.986-74.986v-45.268 c0-41.242,33.744-74.986,74.986-74.986h26.422c41.242,0,74.986,33.744,74.986,74.986v45.268 C640.35,724.478,606.606,758.222,565.364,758.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M565.364,761.688h-26.422c-43.259,0-78.454-35.193-78.454-78.453v-45.269 c0-43.26,35.194-78.453,78.454-78.453h26.422c43.26,0,78.453,35.193,78.453,78.453v45.269 C643.817,726.495,608.624,761.688,565.364,761.688z M538.942,566.447c-39.436,0-71.519,32.084-71.519,71.519v45.269 c0,39.435,32.083,71.519,71.519,71.519h26.422c39.435,0,71.519-32.084,71.519-71.519v-45.269 c0-39.435-32.084-71.519-71.519-71.519H538.942z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_577_",
    style: {
      fill: "#444445"
    },
    d: "M614.403,495.409c-0.103-0.899-0.246-1.782-0.438-2.646 c-1.439-6.478-3.937-12.764-8.043-18.028c-5.385-6.904-13.035-11.224-20.497-14.865c-9.473-4.615-21.613-6.262-26.395-6.758 c-15.185-1.554-32.287,1.654-46.911,8.827c-7.919,3.892-14.67,9.481-19.515,16.16c-4.589,6.318-6.445,13.411-8.243,20.268 c-1.396,5.32-2.714,10.347-5.202,14.888c-0.744,0.596-2.102,1.735-2.112,3.658c-0.015,2.137,1.7,3.496,2.345,4.008 c1.974,1.564,4.583,2.645,7.539,3.129c7.411,1.212,14.586-1.145,20.362-3.04c9.922-3.256,18.589-1.683,32.569-11.069 c11.461-7.695,12.29-29.66,35.855-16.144c10.137-2.678,13.66-0.598,14.397,12.577c0.232,4.155,7.106,9.839,10.77,11.825 c1.56,0.846,3.21,1.449,4.8,2.22c1.46,0.707,3.814,2.882,5.52,2.437c1.041-0.271,1.479-1.492,1.672-2.551 c0.296-1.621,0.404-3.269,0.511-4.913C613.802,509.09,615.141,501.856,614.403,495.409z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_400_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADB"
    },
    d: "M510.741,568.577c0,0,11.877,12.691,40.838,12.691c28.961,0,44.275-11.714,44.275-11.714 l-9.823-3.661c0,0-16.533,6.331-32.977,6.331c-16.444,0-33.284-6.758-33.284-6.758L510.741,568.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M551.579,583.708c-29.678,0-42.105-12.913-42.62-13.463c-0.565-0.604-0.786-1.453-0.587-2.256 c0.199-0.803,0.792-1.45,1.574-1.72l9.03-3.111c0.554-0.191,1.16-0.176,1.703,0.042c0.165,0.066,16.616,6.583,32.376,6.583 c15.779,0,31.944-6.108,32.105-6.17c0.553-0.213,1.167-0.217,1.725-0.008l9.822,3.661c0.832,0.31,1.431,1.049,1.562,1.927 c0.131,0.879-0.226,1.759-0.932,2.299C596.685,571.991,581.029,583.708,551.579,583.708z M515.688,569.454 c1.455,1.007,3.426,2.207,5.946,3.4c5.75,2.725,15.613,5.973,29.945,5.973c19.46,0,32.564-5.433,38.731-8.735l-4.284-1.597 c-3.702,1.325-18.24,6.169-32.971,6.169c-14.792,0-29.616-5.203-33.331-6.601L515.688,569.454z M510.741,568.577h0.01H510.741z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_578_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_579_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_580_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_729_",
    style: {
      fill: "#444445"
    },
    d: "M601.35,546.006c-0.057,14.881-21.681,26.904-48.299,26.854l-0.93-0.002 c-26.618-0.05-48.15-12.154-48.093-27.034l0.207-54.403c0.057-14.881,21.681-26.904,48.299-26.854l0.93,0.002 c26.618,0.05,48.15,12.154,48.093,27.034L601.35,546.006z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_723_",
    style: {
      fill: "#444445"
    },
    d: "M553.465,464.568l-0.02,0v108.287c26.436-0.069,47.849-12.042,47.906-26.849 l0.208-54.403C601.615,476.722,580.082,464.618,553.465,464.568z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_581_",
    style: {
      fill: "#444445"
    },
    d: "M553.216,573.497c-0.056,0-0.109,0-0.166,0l-0.931-0.002 c-13.079-0.025-25.372-2.899-34.617-8.096c-9.304-5.23-14.412-12.182-14.384-19.577l0.208-54.403 c0.058-15.177,22.044-27.49,49.044-27.49c0.056,0,0.109,0,0.166,0l0.929,0.001c13.08,0.025,25.373,2.899,34.617,8.096 c9.304,5.23,14.412,12.182,14.383,19.577l-0.207,54.403C602.202,561.184,580.216,573.497,553.216,573.497z M552.371,465.203 c-26.002,0-47.171,11.742-47.226,26.219l-0.208,54.403c-0.027,7,4.84,13.599,13.703,18.581 c8.924,5.016,20.815,7.792,33.484,7.815l0.93,0.002c0.052,0,0.109,0,0.162,0c26.001,0,47.17-11.743,47.225-26.22l0.909,0.002 l-0.909-0.002l0.207-54.403c0.027-7-4.84-13.599-13.703-18.581c-8.924-5.016-20.815-7.792-33.483-7.815l-0.929-0.001 C552.479,465.203,552.424,465.203,552.371,465.203z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_574_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B76C65"
    },
    d: "M601.558,558.022h8.464c3.887,0,7.068-3.181,7.068-7.068v-31.943c0-3.887-3.18-7.068-7.068-7.068 h-8.464V558.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M610.022,560.334h-10.775v-50.701h10.775c5.172,0,9.379,4.207,9.379,9.379v31.942 C619.401,556.126,615.194,560.334,610.022,560.334z M603.87,555.711h6.152c2.622,0,4.756-2.134,4.756-4.757v-31.942 c0-2.622-2.134-4.756-4.756-4.756h-6.152V555.711z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_573_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B76C65"
    },
    d: "M504.028,558.022h-8.464c-3.887,0-7.068-3.181-7.068-7.068v-31.943 c0-3.887,3.18-7.068,7.068-7.068h8.464V558.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M506.34,560.334h-10.775c-5.171,0-9.379-4.208-9.379-9.38v-31.942 c0-5.172,4.207-9.379,9.379-9.379h10.775V560.334z M495.565,514.256c-2.623,0-4.756,2.134-4.756,4.756v31.942 c0,2.623,2.133,4.757,4.756,4.757h6.152v-41.455H495.565z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_557_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B76C65"
    },
    d: "M601.558,511.944c0,0,3.069-47.105-49.024-47.105c-52.092,0-48.506,47.105-48.506,47.105h-7.766 c0,0-3.342-57.194,55.89-57.194s57.171,57.194,57.171,57.194H601.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M611.553,514.256h-12.462l0.16-2.461c0.017-0.275,0.996-18.823-11.172-31.777 c-8.021-8.538-19.98-12.867-35.545-12.867c-15.554,0-27.457,4.322-35.377,12.848c-12.057,12.977-10.837,31.587-10.823,31.774 l0.183,2.481l-12.434,0.003l-0.127-2.177c-0.062-1.056-1.321-26.051,15.153-43.516c10.092-10.699,24.575-16.124,43.045-16.124 c18.471,0,33.068,5.425,43.39,16.124c16.828,17.445,16.129,42.41,16.091,43.464L611.553,514.256z M603.903,509.633h3.079 c-0.252-6.322-2.104-24.756-14.795-37.889c-9.414-9.742-22.884-14.682-40.034-14.682c-17.147,0-30.497,4.936-39.682,14.673 c-12.438,13.186-13.828,31.635-13.922,37.897h3.11c0.037-5.914,1.271-21.085,12.078-32.745 c8.831-9.529,21.884-14.36,38.798-14.36c16.915,0,30.02,4.832,38.95,14.362C602.417,488.558,603.804,503.74,603.903,509.633z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_583_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_720_",
    d: "M550.531,917.16h-2.351c-5.498,0-9.997-4.499-9.997-9.997v-77.841c0-5.498,4.499-9.997,9.997-9.997h2.351 c5.498,0,9.997,4.499,9.997,9.997v77.841C560.528,912.662,556.029,917.16,550.531,917.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_717_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M550.53,923.187h-2.351c-8.243,0-14.949-6.706-14.949-14.949v-77.841 c0-8.243,6.706-14.949,14.949-14.949h2.351c8.243,0,14.95,6.706,14.95,14.949v77.841 C565.48,916.481,558.773,923.187,550.53,923.187z M548.179,825.352c-2.782,0-5.045,2.263-5.045,5.045v77.841 c0,2.782,2.263,5.045,5.045,5.045h2.351c2.782,0,5.046-2.263,5.046-5.045v-77.841c0-2.782-2.264-5.045-5.046-5.045H548.179z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_705_",
    d: "M640.899,935.9H456.21c0,0,0.297-5.278,0.297-11.729l0,0c0-6.451,6.013-11.729,13.362-11.729h157.966 c7.349,0,13.362,5.278,13.362,11.729l0,0C641.196,930.622,640.899,935.9,640.899,935.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M641.493,939.058H456.804c-0.868,0-1.698-0.357-2.294-0.988c-0.596-0.631-0.907-1.479-0.858-2.347 c0.003-0.052,0.293-5.273,0.293-11.551c0-8.209,7.41-14.887,16.518-14.887h157.966c9.109,0,16.52,6.678,16.52,14.886 c0,6.466-0.29,11.688-0.303,11.907C644.55,937.75,643.168,939.058,641.493,939.058z M460.102,932.743h178.369 c0.078-2.125,0.162-5.195,0.162-8.571c0-4.727-4.578-8.572-10.205-8.572H470.462c-5.626,0-10.204,3.845-10.204,8.571 C460.258,927.545,460.179,930.58,460.102,932.743z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_800_",
    d: "M641.224,935.191H502.977c0,0,0.222-5.278,0.222-11.729l0,0c0-6.451,4.501-11.729,10.002-11.729h118.244 c5.501,0,10.002,5.278,10.002,11.729l0,0C641.447,929.913,641.224,935.191,641.224,935.191z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_799_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M641.669,937.922H503.421c-0.745,0-1.456-0.304-1.972-0.841c-0.515-0.537-0.789-1.262-0.757-2.006 c0.002-0.052,0.22-5.3,0.22-11.613c0-7.974,5.712-14.46,12.733-14.46h118.244c7.021,0,12.733,6.486,12.733,14.46 c0,6.435-0.222,11.79-0.224,11.843C644.337,936.768,643.133,937.922,641.669,937.922z M506.246,932.459h132.782 c0.062-2.142,0.132-5.396,0.132-8.997c0-4.877-3.329-8.997-7.271-8.997H513.646c-3.941,0-7.27,4.12-7.27,8.997 C506.376,927.034,506.307,930.274,506.246,932.459z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_699_",
    cx: 472.244,
    cy: 948.074,
    r: 12.768
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_695_",
    cx: 627.241,
    cy: 948.074,
    r: 12.768
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_682_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M472.244,963.403c-8.453,0-15.33-6.877-15.33-15.329c0-8.452,6.877-15.329,15.33-15.329 c8.453,0,15.329,6.877,15.329,15.329C487.574,956.526,480.697,963.403,472.244,963.403z M472.244,937.868 c-5.628,0-10.207,4.578-10.207,10.206c0,5.628,4.579,10.206,10.207,10.206c5.628,0,10.206-4.578,10.206-10.206 C482.451,942.446,477.872,937.868,472.244,937.868z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_804_",
    transform: "matrix(0.1595 -0.9872 0.9872 0.1595 -497.992 1312.6287)",
    cx: 521.907,
    cy: 948.784,
    rx: 12.768,
    ry: 12.768
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_803_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M521.907,964.113c-8.453,0-15.33-6.877-15.33-15.33c0-8.452,6.877-15.329,15.33-15.329 c8.453,0,15.33,6.877,15.33,15.329C537.236,957.236,530.359,964.113,521.907,964.113z M521.907,938.577 c-5.628,0-10.207,4.578-10.207,10.206c0,5.628,4.579,10.207,10.207,10.207c5.628,0,10.207-4.579,10.207-10.207 C532.113,943.155,527.535,938.577,521.907,938.577z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_679_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M627.241,963.403c-8.452,0-15.329-6.877-15.329-15.329c0-8.452,6.877-15.329,15.329-15.329 c8.452,0,15.329,6.877,15.329,15.329C642.57,956.526,635.693,963.403,627.241,963.403z M627.241,937.868 c-5.628,0-10.206,4.578-10.206,10.206c0,5.628,4.578,10.206,10.206,10.206c5.628,0,10.206-4.578,10.206-10.206 C637.447,942.446,632.869,937.868,627.241,937.868z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_405_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M554.342,817.338h-7.768c-9.591,0-17.393-7.803-17.393-17.394v-99.303 c0-9.591,7.803-17.394,17.393-17.394h7.768c9.59,0,17.393,7.803,17.393,17.394v99.303 C571.735,809.535,563.932,817.338,554.342,817.338z M546.574,696.398c-2.3,0-4.243,1.943-4.243,4.243v99.303 c0,2.3,1.943,4.243,4.243,4.243h7.768c2.299,0,4.243-1.943,4.243-4.243v-99.303c0-2.3-1.943-4.243-4.243-4.243H546.574z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_408_",
    x: 465.91,
    y: 622.128,
    style: {
      fill: "#D2C7B8"
    },
    width: 171.524,
    height: 103.731
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_393_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M637.434,732.931H465.91c-3.455,0-6.255-2.8-6.255-6.255V622.944c0-3.455,2.801-6.255,6.255-6.255 h171.524c3.455,0,6.255,2.8,6.255,6.255v103.732C643.689,730.131,640.889,732.931,637.434,732.931z M472.165,720.421h159.014 v-91.222H472.165V720.421z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_454_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_538_",
    style: {
      fill: "#D2C7B8"
    },
    d: "M650.461,823.4H445.413l0.005-17.162v-3.575c0-9.439,11.186-17.162,24.858-17.162 h155.361c13.672,0,24.858,7.723,24.858,17.162v3.575L650.461,823.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_406_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M651.854,827.734H446.806c-0.904,0-1.771-0.359-2.411-0.998c-0.639-0.64-0.998-1.507-0.997-2.411 l0.005-20.736c0-11.343,12.68-20.57,28.266-20.57H627.03c15.586,0,28.267,9.227,28.267,20.57l-0.034,20.744 C655.258,826.213,653.734,827.734,651.854,827.734z M450.215,820.918h198.237l0.027-17.329c0-7.455-9.823-13.754-21.45-13.754 H471.669c-11.626,0-21.449,6.299-21.449,13.754L450.215,820.918z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_674_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M637.862,651.81H466.285c-3.311,0-5.996-2.685-5.996-5.996c0-3.312,2.685-5.996,5.996-5.996 h171.577c3.312,0,5.996,2.685,5.996,5.996C643.858,649.126,641.173,651.81,637.862,651.81z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_675_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M630.9,678.486H474.895c-3.158,0-5.717-2.561-5.717-5.718c0-3.157,2.559-5.718,5.717-5.718H630.9 c3.157,0,5.718,2.561,5.718,5.718C636.618,675.926,634.057,678.486,630.9,678.486z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_676_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M630.9,705.44H474.895c-3.158,0-5.717-2.561-5.717-5.718c0-3.157,2.559-5.718,5.717-5.718H630.9 c3.157,0,5.718,2.561,5.718,5.718C636.618,702.88,634.057,705.44,630.9,705.44z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1278_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1293_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M364.517,312.42c-40.063,0-72.658-32.595-72.658-72.658s32.594-72.658,72.658-72.658 s72.658,32.595,72.658,72.658S404.581,312.42,364.517,312.42z M364.517,174.57c-35.946,0-65.191,29.245-65.191,65.191 s29.245,65.191,65.191,65.191s65.191-29.245,65.191-65.191S400.464,174.57,364.517,174.57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1292_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M364.621,296.478c-31.331,0-56.82-25.489-56.82-56.82s25.489-56.82,56.82-56.82 c31.331,0,56.82,25.489,56.82,56.82S395.951,296.478,364.621,296.478z M364.621,186.572c-29.272,0-53.086,23.814-53.086,53.086 s23.814,53.086,53.086,53.086s53.086-23.814,53.086-53.086S393.893,186.572,364.621,186.572z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1291_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M364.739,197.22c-1.236,0-2.242-1.006-2.242-2.242v-6.518c0-1.235,1.006-2.241,2.242-2.241 c1.236,0,2.242,1.006,2.242,2.241v6.518C366.981,196.214,365.975,197.22,364.739,197.22z M364.739,188.218 c-0.131,0-0.242,0.11-0.242,0.241v6.518c0,0.262,0.483,0.262,0.483,0v-6.518C364.981,188.328,364.87,188.218,364.739,188.218z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1290_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M396.298,210.389c-0.6,0-1.162-0.232-1.585-0.655l0,0c0,0,0,0,0,0h0 c-0.422-0.423-0.655-0.985-0.655-1.585c0-0.6,0.232-1.162,0.655-1.585l4.61-4.609c0.844-0.846,2.327-0.846,3.171,0 c0.422,0.422,0.655,0.984,0.655,1.585c0,0.601-0.233,1.163-0.656,1.585l-4.609,4.609 C397.461,210.156,396.899,210.389,396.298,210.389z M400.908,203.299c-0.038,0-0.11,0.009-0.17,0.069l-4.61,4.609 c-0.06,0.061-0.069,0.133-0.069,0.171c0,0.038,0.009,0.11,0.069,0.171c0.001,0,0.001,0,0.001,0c0.121,0.121,0.221,0.121,0.341,0 l4.61-4.609c0.06-0.061,0.069-0.133,0.069-0.171c0-0.038-0.009-0.11-0.069-0.171 C401.019,203.308,400.946,203.299,400.908,203.299z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1289_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M415.82,242.019h-6.519c-1.236,0-2.242-1.006-2.242-2.241c0-1.236,1.006-2.242,2.242-2.242h6.519 c1.236,0,2.242,1.006,2.242,2.242C418.062,241.013,417.056,242.019,415.82,242.019z M409.301,239.535 c-0.131,0-0.242,0.111-0.242,0.242c0,0.131,0.111,0.241,0.242,0.241h6.519c0.131,0,0.242-0.11,0.242-0.241 c0-0.131-0.111-0.242-0.242-0.242H409.301z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1288_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M400.74,278.185c-0.6,0-1.163-0.232-1.586-0.655l-4.609-4.609 c-0.422-0.422-0.655-0.984-0.655-1.585c0-0.6,0.232-1.162,0.655-1.585c0,0,0,0,0,0c0.874-0.873,2.296-0.873,3.169,0l4.61,4.609 c0.423,0.423,0.655,0.985,0.655,1.585c0,0.601-0.233,1.163-0.656,1.585C401.903,277.953,401.34,278.185,400.74,278.185z  M395.96,271.165c-0.06,0.061-0.069,0.134-0.069,0.171c0,0.038,0.009,0.11,0.069,0.171l4.61,4.609 c0.121,0.121,0.221,0.121,0.341,0c0.061-0.061,0.07-0.133,0.07-0.171c0-0.038-0.009-0.11-0.07-0.171l-4.609-4.609 C396.21,271.074,396.053,271.073,395.96,271.165z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1287_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M364.502,293.1c-1.236,0-2.242-1.006-2.242-2.242v-6.518c0-1.236,1.006-2.242,2.242-2.242 c1.236,0,2.242,1.006,2.242,2.242v6.518C366.743,292.094,365.737,293.1,364.502,293.1z M364.502,284.097 c-0.131,0-0.242,0.111-0.242,0.242v6.518c0,0.262,0.483,0.262,0.483,0v-6.518C364.743,284.208,364.632,284.097,364.502,284.097z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1286_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M328.333,278.018c-0.6,0-1.163-0.232-1.585-0.655c-0.422-0.422-0.655-0.984-0.655-1.585 c0-0.6,0.232-1.162,0.655-1.585l4.61-4.609c0.874-0.872,2.296-0.874,3.17,0c0.423,0.422,0.656,0.984,0.656,1.585 s-0.233,1.163-0.656,1.585l-4.609,4.609C329.496,277.785,328.933,278.018,328.333,278.018z M332.943,270.928 c-0.063,0-0.125,0.023-0.172,0.069l-4.609,4.609c-0.06,0.061-0.069,0.133-0.069,0.171c0,0.038,0.009,0.11,0.069,0.171 c0.122,0.121,0.222,0.121,0.342,0l4.61-4.609c0.06-0.061,0.069-0.133,0.069-0.171s-0.009-0.11-0.069-0.171 C333.068,270.951,333.005,270.928,332.943,270.928z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1285_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M319.94,241.781h-6.519c-1.236,0-2.242-1.006-2.242-2.242c0-1.235,1.006-2.241,2.242-2.241h6.519 c1.236,0,2.242,1.006,2.242,2.241C322.182,240.775,321.176,241.781,319.94,241.781z M313.421,239.298 c-0.131,0-0.242,0.11-0.242,0.241c0,0.131,0.111,0.242,0.242,0.242h6.519c0.131,0,0.242-0.111,0.242-0.242 c0-0.131-0.111-0.241-0.242-0.241H313.421z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1284_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M333.111,210.221c-0.6,0-1.163-0.232-1.586-0.655l-4.609-4.609 c-0.423-0.423-0.655-0.985-0.655-1.585c0-0.601,0.233-1.163,0.656-1.585c0.843-0.845,2.326-0.845,3.17,0l4.609,4.609 c0.422,0.422,0.655,0.984,0.655,1.585c0,0.6-0.232,1.162-0.655,1.585l0,0h0c0,0,0,0,0,0 C334.273,209.988,333.711,210.221,333.111,210.221z M328.502,203.131c-0.038,0-0.111,0.009-0.171,0.069 c-0.061,0.061-0.07,0.133-0.07,0.171s0.009,0.11,0.07,0.171l4.609,4.609c0.121,0.121,0.221,0.121,0.341,0c0,0,0,0,0,0 c0.06-0.061,0.069-0.133,0.069-0.171s-0.009-0.11-0.069-0.171l-4.61-4.609C328.612,203.14,328.539,203.131,328.502,203.131z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1281_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1283_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M361.319,245.663C361.318,245.663,361.318,245.663,361.319,245.663 c-0.695,0-1.347-0.27-1.836-0.759l-0.081-0.081c-1.015-1.017-1.015-2.663-0.004-3.674l1.515-1.515 c0.391-0.391,1.023-0.391,1.414,0c0.391,0.391,0.391,1.023,0,1.414l-1.515,1.515c-0.228,0.227-0.228,0.613,0,0.842l0.082,0.081 c0.116,0.115,0.265,0.177,0.424,0.177h0.001c0.16,0,0.309-0.062,0.42-0.173l1.522-1.522c0.39-0.391,1.023-0.391,1.414,0 c0.391,0.391,0.391,1.023,0,1.414l-1.522,1.522C362.665,245.394,362.013,245.663,361.319,245.663z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1282_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M366.478,241.167c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414 l24.42-24.421c0.111-0.111,0.172-0.261,0.172-0.421c0-0.16-0.061-0.31-0.172-0.421l-0.087-0.088 c-0.226-0.225-0.611-0.227-0.84,0.002l-24.413,24.413c-0.391,0.391-1.023,0.391-1.414,0c-0.391-0.391-0.391-1.023,0-1.414 l24.413-24.413c1.012-1.012,2.657-1.012,3.67,0l0.087,0.088c0.487,0.486,0.756,1.139,0.756,1.833 c0,0.694-0.27,1.347-0.758,1.835l-24.42,24.421C366.989,241.069,366.733,241.167,366.478,241.167z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1279_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1280_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M366.402,245.374c-0.745,0-1.443-0.289-1.968-0.813l-13.431-13.431 c-1.085-1.085-1.085-2.85-0.001-3.935c1.05-1.049,2.888-1.049,3.936,0l13.431,13.431c1.085,1.085,1.085,2.85,0,3.934h0 C367.846,245.085,367.147,245.374,366.402,245.374z M367.663,243.854h0.01H367.663z M352.971,228.382 c-0.21,0-0.407,0.081-0.553,0.228c-0.305,0.305-0.305,0.802,0,1.106l13.431,13.431c0.293,0.292,0.813,0.294,1.107,0 c0.305-0.305,0.305-0.802,0-1.107l-13.431-13.431C353.378,228.463,353.182,228.382,352.971,228.382z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1296_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3332_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3333_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3342_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3351_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3352_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3353_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3362_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3372_",
    style: {
      fill: "#424243"
    },
    d: "M872.682,892.519c-1.184,0-2.143-1.49-2.143-3.331V767.181 c0-1.841,0.959-3.331,2.143-3.331c1.185,0,2.143,1.49,2.143,3.331v122.007 C874.825,891.029,873.867,892.519,872.682,892.519z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3249_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3309_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3310_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3311_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3330_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3331_",
    style: {
      fill: "#BAD387"
    },
    d: "M875.275,833.516c0,0,32.132,0.473,34.924-31.527 C910.199,801.988,879.999,804.17,875.275,833.516z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3258_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3267_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3268_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3269_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3278_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3288_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3289_",
    style: {
      fill: "#424243"
    },
    d: "M875.271,836.615c-0.024,0-0.036,0-0.042,0 c-0.899-0.012-1.749-0.418-2.327-1.107c-0.581-0.69-0.829-1.595-0.687-2.485c5.06-31.405,37.433-34.104,37.76-34.125 c0.944-0.067,1.794,0.269,2.43,0.914c0.638,0.648,0.959,1.54,0.88,2.445C910.325,836.192,876.654,836.615,875.271,836.615 z M906.576,805.673c-7.29,1.531-22.72,6.818-27.426,24.481C886.707,829.21,902.981,824.934,906.576,805.673z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3195_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3226_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3227_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3235_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3236_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3246_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3247_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3248_",
    style: {
      fill: "#BAD387"
    },
    d: "M845.747,827.755c0,0-1.011,26.953,25.787,29.907 C871.535,857.663,870.281,832.28,845.747,827.755z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3196_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3204_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3205_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3206_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3214_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3215_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3216_",
    style: {
      fill: "#424243"
    },
    d: "M871.534,860.263c-0.094,0-0.191-0.005-0.285-0.015 c-28.868-3.182-28.114-32.297-28.101-32.589c0.028-0.757,0.384-1.46,0.973-1.933c0.589-0.472,1.354-0.658,2.098-0.528 c26.254,4.843,27.898,32.063,27.913,32.337c0.038,0.76-0.262,1.499-0.815,2.022 C872.832,860.011,872.192,860.263,871.534,860.263z M848.495,831.072c0.648,6.36,3.924,20.095,20.014,23.481 C867.364,848.404,863.223,835.357,848.495,831.072z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1428_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2520_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3175_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3176_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3184_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3185_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3186_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3194_",
    style: {
      fill: "#BAD387"
    },
    d: "M841.646,779.329c0,0-1.157,30.847,29.513,34.229 C871.16,813.558,869.724,784.508,841.646,779.329z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1429_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1436_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1437_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1438_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1439_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1446_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1447_",
    style: {
      fill: "#424243"
    },
    d: "M871.158,816.536c-0.107,0-0.218-0.006-0.326-0.017 c-33.039-3.645-32.176-36.966-32.161-37.301c0.032-0.866,0.439-1.671,1.113-2.212c0.674-0.54,1.552-0.756,2.401-0.604 c30.048,5.543,31.929,36.699,31.946,37.013c0.043,0.869-0.299,1.715-0.933,2.314 C872.643,816.248,871.911,816.536,871.158,816.536z M844.79,783.125c0.741,7.279,4.491,22.999,22.906,26.874 C866.385,802.964,861.647,788.028,844.79,783.125z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1319_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1369_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1370_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1417_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1418_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1419_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1420_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1421_",
    style: {
      fill: "#BAD387"
    },
    d: "M872.66,784.088c0,0,15.805-19.809-2.803-36.996 C869.857,747.092,856.642,766.977,872.66,784.088z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1321_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1322_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1363_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1364_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1365_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1366_",
    style: {
      fill: "#424243"
    },
    d: "M872.66,786.531c-0.675,0-1.322-0.279-1.785-0.773 c-17.141-18.31-3.195-39.803-3.052-40.018c0.396-0.596,1.033-0.988,1.744-1.074c0.721-0.096,1.424,0.146,1.95,0.632 c20.042,18.513,3.226,40.096,3.052,40.313c-0.442,0.554-1.103,0.888-1.814,0.916 C872.724,786.531,872.691,786.531,872.66,786.531z M870.409,751.13c-2.565,5.286-6.717,17.46,2.024,28.917 C875.492,774.878,880.682,762.668,870.409,751.13z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1297_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1312_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1313_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1314_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1315_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1316_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1317_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1318_",
    style: {
      fill: "#BAD387"
    },
    d: "M873.146,790.975c0,0,25.206-2.607,24.427-27.926 C897.573,763.049,874.126,767.557,873.146,790.975z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1298_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1299_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1304_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1307_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1308_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1309_",
    style: {
      fill: "#424243"
    },
    d: "M873.146,793.417c-0.618,0-1.219-0.236-1.675-0.663 c-0.515-0.487-0.797-1.174-0.766-1.883c1.048-25.058,26.151-30.172,26.407-30.222c0.706-0.131,1.429,0.045,1.988,0.494 c0.558,0.446,0.892,1.117,0.916,1.83c0.84,27.275-26.344,30.404-26.619,30.432 C873.314,793.413,873.23,793.417,873.146,793.417z M895.076,766.271c-5.567,1.875-17.16,7.445-19.205,21.71 C881.701,786.542,894.045,781.687,895.076,766.271z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_394_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1133_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1144_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1145_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1146_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1147_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1247_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1277_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1294_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1295_",
    x: 850.555,
    y: 880.724,
    style: {
      fill: "#EEEFEF"
    },
    width: 47.637,
    height: 49.454
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1134_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1135_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1136_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1137_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1139_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1140_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1141_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1142_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1143_",
    style: {
      fill: "#424243"
    },
    d: "M898.192,928.229c-13.896,0-27.792,0-41.688,0 c-1.983,0-3.966,0-5.949,0c0.462,0.65,0.924,1.3,1.386,1.95c0-16.484,0-32.969,0-49.454 c-0.462,0.65-0.924,1.3-1.386,1.95c13.896,0,27.792,0,41.687,0c1.983,0,3.966,0,5.95,0 c-0.462-0.65-0.924-1.3-1.386-1.95c0,16.485,0,32.969,0,49.454c0,2.509,2.771,2.513,2.771,0c0-16.484,0-32.969,0-49.454 c0-1.054-0.635-1.95-1.385-1.95c-13.896,0-27.792,0-41.688,0c-1.983,0-3.966,0-5.949,0c-0.749,0-1.386,0.893-1.386,1.95 c0,16.485,0,32.969,0,49.454c0,1.054,0.635,1.95,1.386,1.95c13.896,0,27.792,0,41.687,0c1.983,0,3.966,0,5.95,0 C899.975,932.128,899.978,928.229,898.192,928.229z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_430_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_553_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_554_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_555_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_556_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_563_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_886_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1131_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1132_",
    x: 844.731,
    y: 871.144,
    style: {
      fill: "#EEEFEF"
    },
    width: 59.284,
    height: 9.674
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_431_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_545_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_546_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_547_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_548_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_549_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_550_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_551_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_552_",
    style: {
      fill: "#424243"
    },
    d: "M904.016,878.869c-17.302,0-34.605,0-51.907,0c-2.459,0-4.918,0-7.377,0 c0.462,0.65,0.924,1.3,1.386,1.949c0-3.225,0-6.45,0-9.674c-0.462,0.65-0.924,1.3-1.386,1.95 c17.303,0,34.605,0,51.908,0c2.459,0,4.918,0,7.377,0c-0.462-0.65-0.924-1.3-1.385-1.95c0,3.225,0,6.45,0,9.674 c0,2.509,2.771,2.513,2.771,0c0-3.225,0-6.45,0-9.674c0-1.054-0.635-1.95-1.386-1.95c-17.302,0-34.605,0-51.907,0 c-2.459,0-4.918,0-7.377,0c-0.749,0-1.386,0.893-1.386,1.95c0,3.225,0,6.45,0,9.674c0,1.054,0.635,1.95,1.386,1.95 c17.303,0,34.605,0,51.908,0c2.459,0,4.918,0,7.377,0C905.799,882.768,905.802,878.869,904.016,878.869z"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3964_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M359.734,882.014h-74.5c-1.664,0-3.013-1.35-3.013-3.014s1.349-3.014,3.013-3.014h74.5 c1.664,0,3.013,1.35,3.013,3.014S361.398,882.014,359.734,882.014z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3965_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444445"
    },
    d: "M815.234,882.014h-74.5c-1.664,0-3.014-1.35-3.014-3.014s1.35-3.014,3.014-3.014h74.5 c1.664,0,3.014,1.35,3.014,3.014S816.898,882.014,815.234,882.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1448_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1473_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M665.336,177.281c-1.104,0-2-0.895-2-2V5.745c0-1.104,0.896-2,2-2s2,0.896,2,2v169.536 C667.336,176.386,666.44,177.281,665.336,177.281z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1470_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1472_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AE3C"
    },
    d: "M665.935,208.001h-1.937c-5.217,0-9.486-4.268-9.486-9.486v-13.748 c0-5.217,4.269-9.486,9.486-9.486h1.937c5.217,0,9.486,4.269,9.486,9.486v13.748 C675.421,203.732,671.152,208.001,665.935,208.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M665.935,208.501h-1.937c-5.506,0-9.986-4.48-9.986-9.985v-13.748 c0-5.507,4.479-9.986,9.986-9.986h1.937c5.506,0,9.985,4.48,9.985,9.986v13.748 C675.921,204.021,671.441,208.501,665.935,208.501z M663.998,175.781c-4.955,0-8.986,4.031-8.986,8.986v13.748 c0,4.954,4.031,8.985,8.986,8.985h1.937c4.955,0,8.985-4.031,8.985-8.985v-13.748c0-4.955-4.031-8.986-8.985-8.986H663.998z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1471_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M666.254,210.001h-1.937c-6.333,0-11.485-5.152-11.485-11.485v-13.748 c0-6.334,5.152-11.486,11.485-11.486h1.937c6.333,0,11.486,5.152,11.486,11.486v13.748 C677.74,204.849,672.588,210.001,666.254,210.001z M664.317,177.281c-4.128,0-7.485,3.358-7.485,7.486v13.748 c0,4.127,3.358,7.485,7.485,7.485h1.937c4.128,0,7.486-3.358,7.486-7.485v-13.748c0-4.128-3.358-7.486-7.486-7.486H664.317z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1468_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AE3C"
    },
    d: "M673.08,10.019h-15.488c-2.154,0-3.916-1.762-3.916-3.916V5.387 c0-2.154,1.762-3.916,3.916-3.916h15.488c2.154,0,3.916,1.762,3.916,3.916v0.717C676.996,8.257,675.234,10.019,673.08,10.019z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M673.08,10.519h-15.488c-2.435,0-4.416-1.981-4.416-4.416V5.387 c0-2.435,1.981-4.416,4.416-4.416h15.488c2.435,0,4.416,1.981,4.416,4.416v0.717C677.496,8.538,675.515,10.519,673.08,10.519z  M657.592,1.971c-1.884,0-3.416,1.532-3.416,3.416v0.717c0,1.884,1.532,3.416,3.416,3.416h15.488 c1.884,0,3.416-1.532,3.416-3.416V5.387c0-1.884-1.532-3.416-3.416-3.416H657.592z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1467_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M673.08,12.019h-15.488c-3.262,0-5.916-2.654-5.916-5.916V5.387 c0-3.262,2.654-5.916,5.916-5.916h15.488c3.262,0,5.916,2.654,5.916,5.916v0.717C678.996,9.365,676.342,12.019,673.08,12.019z  M657.592,3.471c-1.057,0-1.916,0.859-1.916,1.916v0.717c0,1.057,0.859,1.916,1.916,1.916h15.488 c1.057,0,1.916-0.859,1.916-1.916V5.387c0-1.057-0.859-1.916-1.916-1.916H657.592z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1449_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1466_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B241"
    },
    d: "M665.08,197.626h10.235l2.394,6.225c0,0,19.951,10.374,26.654,15.163 c6.703,4.788,7.821,9.896,8.459,12.768c0.638,2.873,4.469,23.462,4.469,23.462h-51.473h-52.91c0,0,3.831-20.589,4.469-23.462 c0.638-2.873,1.756-7.98,8.459-12.768c6.703-4.788,26.654-15.163,26.654-15.163l2.394-6.225H665.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M717.892,255.744H612.307l0.11-0.592c0.039-0.206,3.84-20.63,4.472-23.479 c0.64-2.878,1.819-8.183,8.657-13.067c6.328-4.52,24.594-14.092,26.545-15.11l2.45-6.369h21.116l2.45,6.369 c1.954,1.02,20.219,10.591,26.546,15.11c6.838,4.885,8.018,10.189,8.651,13.04c0.639,2.876,4.44,23.3,4.479,23.506 L717.892,255.744z M613.51,254.744h103.179c-0.633-3.393-3.787-20.295-4.356-22.854c-0.653-2.938-1.735-7.809-8.262-12.47 c-6.598-4.714-26.395-15.022-26.594-15.126l-0.168-0.087l-2.338-6.081h-19.743l-2.339,6.081l-0.168,0.087 c-0.199,0.104-19.996,10.413-26.594,15.126c-6.526,4.661-7.609,9.532-8.256,12.442 C617.298,234.446,614.143,251.35,613.51,254.744z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1465_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424243"
    },
    d: "M717.504,258.096H613.121c-0.594,0-1.158-0.265-1.538-0.722 c-0.38-0.457-0.537-1.059-0.428-1.644c0.157-0.842,3.844-20.655,4.482-23.529c0.684-3.074,1.944-8.744,9.249-13.963 c6.121-4.371,22.622-13.074,26.222-14.958l2.123-5.52c0.297-0.772,1.039-1.282,1.867-1.282h20.43 c0.828,0,1.57,0.51,1.867,1.282l2.123,5.52c3.6,1.884,20.101,10.587,26.222,14.958c7.307,5.22,8.566,10.89,9.243,13.936 c0.645,2.9,4.332,22.714,4.489,23.556c0.109,0.585-0.048,1.187-0.428,1.644C718.662,257.831,718.098,258.096,717.504,258.096z  M615.529,254.096h99.568c-1.025-5.491-3.519-18.8-4.014-21.028c-0.606-2.727-1.61-7.247-7.669-11.574 c-6.514-4.652-26.216-14.913-26.415-15.017c-0.433-0.226-0.768-0.601-0.944-1.057l-1.901-4.942h-17.683l-1.901,4.942 c-0.175,0.456-0.511,0.831-0.944,1.057c-0.198,0.104-19.902,10.364-26.415,15.017c-6.058,4.327-7.063,8.847-7.663,11.547 C619.048,235.29,616.554,248.604,615.529,254.096z"
  }))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000098906820914865281990000007994268200833843859_",
    filterUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000098906820914865281990000007994268200833843859_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170252819714925306710000000952293320913098122_",
    gradientUnits: "userSpaceOnUse",
    x1: 666.0306,
    y1: 256.0955,
    x2: 666.0306,
    y2: 452.4629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1105,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3649,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#B7B7B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6384,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7798,
    style: {
      stopColor: "#5D5D5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    style: {
      stopColor: "#242424"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_1_)",
      fill: "url(#SVGID_00000170252819714925306710000000952293320913098122_)"
    },
    points: " 667.095,452.463 806.298,452.463 718.94,256.095 666.031,256.095 613.121,256.095 525.763,452.463 664.967,452.463  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147923738535463070880000015580277134581684661_",
    filterUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367,
    id: "SVGID_00000122695965270871685210000004116281268345943996_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000147923738535463070880000015580277134581684661_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000158741688854657475510000016048232097549913216_",
    filterUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 525.763,
    y: 256.095,
    width: 280.535,
    height: 196.367,
    id: "SVGID_00000122695965270871685210000004116281268345943996_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000158741688854657475510000016048232097549913216_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003072177344308295000000013112011066418131093_",
    gradientUnits: "userSpaceOnUse",
    x1: 666.0306,
    y1: 205.0981,
    x2: 666.0306,
    y2: 461.5402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1105,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3649,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#B7B7B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6384,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7798,
    style: {
      stopColor: "#5D5D5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    style: {
      stopColor: "#242424"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000122695965270871685210000004116281268345943996_)",
      fill: "url(#SVGID_00000003072177344308295000000013112011066418131093_)"
    },
    points: " 667.095,452.463 806.298,452.463 718.94,256.095 666.031,256.095 613.121,256.095 525.763,452.463 664.967,452.463  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143593709054232940250000001358882473911068056_",
    gradientUnits: "userSpaceOnUse",
    x1: 666.0306,
    y1: 205.0981,
    x2: 666.0306,
    y2: 461.5402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000143593709054232940250000001358882473911068056_)"
    },
    points: "667.095,452.463  806.298,452.463 718.94,256.095 666.031,256.095 613.121,256.095 525.763,452.463 664.967,452.463  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.718e7a24c1452b6e214a512ceb924b1e.svg";
export { ForwardRef as ReactComponent };